import {dropShadow} from '@remotion/effects/drop-shadow';
import {tint} from '@remotion/effects/tint';
import {Video} from '@remotion/media';
import React from 'react';
import {Sequence, getStaticFiles, interpolate, useCurrentFrame} from 'remotion';
import {Skills2Announcement} from './Skills2Announcement/index';

export const Skills2Gesture: React.FC = () => {
	const frame = useCurrentFrame();
	const localPuppetHand = getStaticFiles().find(
		(file) => file.name === 'puppet-master-hand.mov',
	);

	return (
		<Sequence
			name="Puppet scene"
			style={{
				translate: '-288px 310px',
			}}
		>
			<Video
				src={
					localPuppetHand?.src ??
					'https://remotion.media/skills-2-announcement/puppet-master-hand.mov'
				}
				durationInFrames={456}
				from={0}
				style={{
					position: 'absolute',
					translate: '-320px -198.6px',
					width: 2560,
					height: 1440,
					scale: 0.7,
				}}
				effects={[
					dropShadow({}),
					tint({
						color: '#1ec8ff',
						amount: 0.06,
					}),
				]}
			/>
			<Sequence
				name="Remotion best practices"
				width={1071}
				height={102}
				durationInFrames={456}
				style={{
					position: 'absolute',
					translate: interpolate(
						frame,
						[
							0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
							19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
							35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
							51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66,
							67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82,
							83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98,
							99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111,
							112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
							125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
							138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150,
							151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163,
							164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176,
							177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
							190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202,
							203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215,
							216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228,
							229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241,
							242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254,
							255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267,
							268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280,
							281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293,
							294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306,
							307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319,
							320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332,
							333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345,
							346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358,
							359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371,
							372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384,
							385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397,
							398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410,
							411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423,
							424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436,
							437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449,
							450, 451, 452, 453, 454, 455,
						],
						[
							'419.6px 306.6px',
							'419.6px 306.6px',
							'419.5px 307px',
							'422.7px 276.1px',
							'422.7px 276.1px',
							'422.7px 276.1px',
							'416.5px 215.6px',
							'416.6px 215.6px',
							'416.6px 215.6px',
							'412.6px 175.3px',
							'412.6px 175.3px',
							'412.6px 175.3px',
							'414.5px 174.6px',
							'414.5px 174.6px',
							'414.5px 174.6px',
							'412px 186.2px',
							'412px 186.2px',
							'412px 186.2px',
							'410.6px 194.6px',
							'410.6px 194.6px',
							'410.6px 194.6px',
							'409.8px 199.1px',
							'409.8px 199.1px',
							'409.8px 199.1px',
							'409.6px 205.1px',
							'409.6px 205.1px',
							'409.7px 205.1px',
							'409px 208.9px',
							'409px 208.9px',
							'408.9px 208.9px',
							'408.9px 210px',
							'409px 210px',
							'409px 210px',
							'408.4px 208.3px',
							'408.3px 207.9px',
							'408.4px 207.9px',
							'409.3px 204px',
							'409.3px 204px',
							'409.3px 204px',
							'410.7px 198.1px',
							'410.7px 198.1px',
							'410.8px 198.4px',
							'411.9px 194.3px',
							'411.9px 194.3px',
							'411.9px 194.3px',
							'411.5px 191.8px',
							'411.5px 191.8px',
							'411.5px 192.1px',
							'410.9px 193.2px',
							'410.9px 193.2px',
							'410.9px 193.2px',
							'411.8px 197.4px',
							'411.8px 197.4px',
							'411.8px 197.4px',
							'410.4px 200.5px',
							'410.4px 200.5px',
							'410.3px 200.5px',
							'410.6px 207.5px',
							'410.6px 207.5px',
							'410.6px 207.5px',
							'409.5px 210px',
							'409.4px 210px',
							'409.4px 210px',
							'409.6px 209.6px',
							'409.7px 210px',
							'409.7px 209.3px',
							'410.2px 206.5px',
							'410.2px 206.5px',
							'410.2px 206.5px',
							'410.6px 200.9px',
							'410.6px 200.9px',
							'410.6px 200.9px',
							'410.5px 195.6px',
							'410.5px 195.6px',
							'410.6px 195.6px',
							'410.8px 192.5px',
							'410.8px 192.5px',
							'410.8px 192.5px',
							'411.1px 191.5px',
							'411.1px 191.5px',
							'411.1px 191.5px',
							'410.7px 194.3px',
							'410.7px 194.3px',
							'410.7px 194.3px',
							'409.7px 199.1px',
							'409.7px 199.5px',
							'409.7px 199.5px',
							'410.2px 204.8px',
							'410.2px 204.8px',
							'410.3px 204.8px',
							'410.3px 209.3px',
							'410.3px 209.3px',
							'410.3px 209.3px',
							'409.7px 210.3px',
							'409.7px 210.3px',
							'409.9px 210.3px',
							'409.8px 208.6px',
							'409.9px 209.3px',
							'409.9px 209.3px',
							'410.4px 204px',
							'410.4px 204px',
							'410.4px 204px',
							'410.8px 198.4px',
							'410.8px 198.4px',
							'410.8px 198.4px',
							'410.6px 194.3px',
							'410.6px 194.3px',
							'410.6px 194.3px',
							'411.9px 192.5px',
							'412px 192.5px',
							'412px 192.5px',
							'411.8px 193.2px',
							'411.8px 193.2px',
							'411.8px 193.2px',
							'410.9px 196.3px',
							'411.1px 196px',
							'411.1px 196.3px',
							'410.7px 202.3px',
							'410.8px 201.9px',
							'410.7px 201.9px',
							'410px 206.5px',
							'410px 206.5px',
							'410px 206.5px',
							'410px 209.6px',
							'409.9px 209.6px',
							'409.8px 210.3px',
							'410.1px 210.7px',
							'410.1px 210.7px',
							'410.1px 210.7px',
							'410.1px 207.2px',
							'410.1px 207.2px',
							'410.1px 207.2px',
							'410.6px 202.3px',
							'410.5px 202.3px',
							'410.4px 202.3px',
							'410.8px 196.7px',
							'410.8px 196.7px',
							'410.8px 196.7px',
							'411.1px 192.5px',
							'411.1px 192.1px',
							'411.2px 192.1px',
							'411.7px 191.8px',
							'411.6px 191.4px',
							'411.5px 191.8px',
							'411.1px 193.9px',
							'411.3px 193.9px',
							'411.3px 193.9px',
							'410.8px 198.5px',
							'410.9px 198.5px',
							'410.9px 198.5px',
							'411.6px 203.4px',
							'411.6px 203.4px',
							'411.6px 203.4px',
							'410.9px 207.5px',
							'410.9px 207.5px',
							'410.3px 207.5px',
							'410.3px 210.2px',
							'410.3px 210.2px',
							'410.3px 210.2px',
							'410.3px 208.8px',
							'410.3px 208.8px',
							'410.3px 208.8px',
							'410.3px 204.8px',
							'410.3px 204.8px',
							'410.3px 204.8px',
							'410.3px 200.1px',
							'410.3px 200.1px',
							'410.3px 200.1px',
							'410.9px 194.7px',
							'410.9px 194.7px',
							'410.9px 194.7px',
							'410.3px 192.0px',
							'410.3px 192.0px',
							'410.3px 192.0px',
							'410.9px 193.3px',
							'411.6px 193.3px',
							'411.6px 193.3px',
							'411.6px 196.7px',
							'411.6px 196.7px',
							'411.6px 196.7px',
							'410.9px 201.4px',
							'410.9px 201.4px',
							'410.9px 201.4px',
							'410.9px 206.1px',
							'410.9px 206.1px',
							'409.6px 206.1px',
							'409.6px 210.2px',
							'409.6px 210.2px',
							'410.3px 210.2px',
							'409.6px 210.2px',
							'409.6px 210.2px',
							'409.6px 210.2px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.3px 202.7px',
							'410.3px 202.7px',
							'410.3px 202.7px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.9px 192.7px',
							'410.9px 192.7px',
							'410.9px 192.7px',
							'412.3px 191.3px',
							'412.3px 191.3px',
							'412.3px 191.3px',
							'411.6px 192.7px',
							'411.6px 192.7px',
							'411.6px 192.7px',
							'411.6px 197.4px',
							'411.6px 197.4px',
							'411.6px 197.4px',
							'410.9px 202.1px',
							'410.9px 202.1px',
							'410.9px 203.4px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.3px 210.2px',
							'410.3px 210.2px',
							'410.3px 210.2px',
							'409.6px 209.5px',
							'409.6px 209.5px',
							'409.6px 209.5px',
							'409.6px 205.4px',
							'409.6px 205.4px',
							'409.6px 205.4px',
							'410.3px 200.1px',
							'410.3px 200.1px',
							'410.3px 200.1px',
							'410.9px 195.3px',
							'410.9px 195.3px',
							'410.9px 195.3px',
							'410.9px 192.7px',
							'410.3px 192.7px',
							'410.3px 192.7px',
							'410.9px 193.3px',
							'410.9px 193.3px',
							'410.9px 193.3px',
							'410.9px 196.0px',
							'410.9px 196.0px',
							'410.9px 196.0px',
							'410.9px 200.7px',
							'410.9px 200.7px',
							'412.3px 200.7px',
							'410.9px 205.4px',
							'410.9px 205.4px',
							'410.9px 205.4px',
							'410.9px 209.5px',
							'410.9px 209.5px',
							'410.9px 209.5px',
							'410.9px 210.2px',
							'410.9px 210.2px',
							'410.9px 210.2px',
							'409.6px 207.5px',
							'409.6px 207.5px',
							'409.6px 206.8px',
							'410.3px 202.1px',
							'410.3px 202.1px',
							'410.3px 202.1px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'412.3px 193.3px',
							'411.6px 193.3px',
							'411.6px 193.3px',
							'412.3px 190.6px',
							'412.3px 190.6px',
							'412.3px 190.6px',
							'411.6px 192.0px',
							'411.6px 192.0px',
							'411.6px 192.0px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.9px 202.1px',
							'410.9px 202.1px',
							'410.9px 202.1px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'409.6px 210.2px',
							'409.6px 210.2px',
							'409.6px 210.2px',
							'410.3px 209.5px',
							'410.3px 209.5px',
							'410.3px 209.5px',
							'410.3px 206.1px',
							'410.3px 206.1px',
							'410.3px 206.1px',
							'410.3px 200.7px',
							'410.3px 200.7px',
							'410.3px 200.7px',
							'410.9px 196.0px',
							'410.3px 196.0px',
							'410.3px 196.0px',
							'410.9px 192.7px',
							'410.9px 192.7px',
							'410.9px 192.7px',
							'410.9px 192.0px',
							'410.9px 192.0px',
							'410.9px 192.0px',
							'410.3px 194.7px',
							'410.3px 194.7px',
							'410.3px 194.7px',
							'410.9px 200.7px',
							'410.9px 200.7px',
							'410.9px 200.7px',
							'410.3px 205.4px',
							'410.3px 205.4px',
							'410.3px 205.4px',
							'410.3px 209.5px',
							'410.3px 208.8px',
							'410.3px 208.8px',
							'410.3px 209.5px',
							'410.3px 209.5px',
							'410.3px 209.5px',
							'410.3px 206.8px',
							'410.3px 206.8px',
							'410.3px 206.8px',
							'411.6px 203.4px',
							'411.6px 203.4px',
							'411.6px 202.7px',
							'410.9px 197.4px',
							'410.9px 197.4px',
							'410.9px 197.4px',
							'411.6px 192.7px',
							'411.6px 192.7px',
							'411.6px 192.7px',
							'411.6px 190.6px',
							'411.6px 190.6px',
							'411.6px 190.6px',
							'412.3px 192.7px',
							'412.3px 192.7px',
							'412.3px 192.7px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.3px 202.1px',
							'410.3px 202.1px',
							'410.3px 202.1px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'409.6px 210.2px',
							'409.6px 210.2px',
							'409.6px 210.2px',
							'409.6px 209.5px',
							'409.6px 209.5px',
							'409.6px 210.2px',
							'410.3px 206.8px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'409.6px 202.1px',
							'410.9px 202.1px',
							'410.9px 202.1px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.9px 192.7px',
							'410.9px 192.7px',
							'410.9px 192.7px',
							'411.6px 192.0px',
							'411.6px 192.0px',
							'410.9px 192.0px',
							'410.3px 194.7px',
							'410.3px 194.7px',
							'410.3px 194.7px',
							'410.3px 198.7px',
							'410.3px 198.7px',
							'410.3px 198.7px',
							'410.3px 204.1px',
							'410.3px 204.1px',
							'410.3px 204.1px',
							'410.9px 208.1px',
							'410.9px 208.1px',
							'410.9px 208.1px',
							'410.3px 209.5px',
							'410.3px 209.5px',
							'410.3px 209.5px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.9px 203.4px',
							'410.9px 203.4px',
							'410.9px 203.4px',
							'410.9px 198.0px',
							'410.9px 198.0px',
							'410.9px 198.0px',
							'411.6px 193.3px',
							'411.6px 193.3px',
							'411.6px 193.3px',
							'411.6px 192.0px',
							'411.6px 192.0px',
							'411.6px 192.7px',
							'410.9px 192.0px',
							'410.9px 192.0px',
							'410.9px 192.0px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.9px 196.7px',
							'410.3px 201.4px',
							'410.3px 201.4px',
							'410.3px 201.4px',
							'410.3px 206.1px',
							'410.3px 206.1px',
							'410.3px 206.8px',
							'410.3px 209.5px',
							'410.3px 209.5px',
							'410.3px 209.5px',
							'409.6px 210.2px',
							'409.6px 210.2px',
							'409.6px 210.2px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.3px 207.5px',
							'410.3px 202.7px',
							'410.3px 202.1px',
							'410.3px 202.1px',
							'410.3px 196.7px',
							'410.3px 196.7px',
							'410.3px 196.7px',
							'410.3px 192.7px',
							'410.3px 192.7px',
							'410.9px 192.7px',
							'411.6px 192.0px',
							'411.6px 192.0px',
							'411.6px 192.0px',
							'412.3px 194.0px',
							'412.3px 194.0px',
							'412.3px 194.0px',
							'411.6px 198.7px',
							'411.6px 198.7px',
							'411.6px 198.7px',
							'410.9px 203.4px',
							'410.9px 203.4px',
							'410.9px 203.4px',
							'410.3px 208.1px',
							'410.3px 208.1px',
							'410.3px 208.1px',
							'410.3px 208.8px',
							'410.3px 208.8px',
							'410.3px 208.8px',
							'410.9px 207.5px',
							'410.9px 207.5px',
							'410.9px 207.5px',
							'410.9px 204.1px',
							'410.9px 204.1px',
							'410.9px 204.1px',
							'410.9px 198.7px',
							'410.9px 198.7px',
							'410.9px 198.7px',
							'410.9px 194.0px',
							'410.9px 194.0px',
							'410.9px 194.0px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					rotate: interpolate(
						frame,
						[
							0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
							19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
							35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
							51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66,
							67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82,
							83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98,
							99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111,
							112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
							125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
							138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150,
							151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163,
							164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176,
							177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
							190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202,
							203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215,
							216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228,
							229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241,
							242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254,
							255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267,
							268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280,
							281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293,
							294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306,
							307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319,
							320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332,
							333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345,
							346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358,
							359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371,
							372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384,
							385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397,
							398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410,
							411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423,
							424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436,
							437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449,
							450, 451, 452, 453, 454, 455,
						],
						[
							'5.19deg',
							'5.19deg',
							'5.31deg',
							'3.86deg',
							'3.86deg',
							'3.86deg',
							'3.61deg',
							'3.61deg',
							'3.61deg',
							'5.59deg',
							'5.59deg',
							'5.59deg',
							'5.84deg',
							'5.84deg',
							'5.84deg',
							'5.97deg',
							'5.97deg',
							'5.97deg',
							'6.56deg',
							'6.56deg',
							'6.56deg',
							'6.93deg',
							'6.93deg',
							'6.93deg',
							'7.32deg',
							'7.32deg',
							'7.32deg',
							'7.71deg',
							'7.71deg',
							'7.71deg',
							'8.06deg',
							'8.06deg',
							'8.06deg',
							'7.96deg',
							'8.06deg',
							'8.08deg',
							'7.7deg',
							'7.7deg',
							'7.69deg',
							'7.26deg',
							'7.26deg',
							'7.16deg',
							'6.86deg',
							'6.86deg',
							'6.86deg',
							'6.53deg',
							'6.53deg',
							'6.43deg',
							'6.35deg',
							'6.35deg',
							'6.35deg',
							'6.74deg',
							'6.74deg',
							'6.74deg',
							'6.56deg',
							'6.56deg',
							'6.56deg',
							'7.61deg',
							'7.61deg',
							'7.61deg',
							'7.83deg',
							'7.82deg',
							'7.82deg',
							'8.15deg',
							'8.05deg',
							'8.04deg',
							'7.99deg',
							'7.99deg',
							'7.99deg',
							'7.51deg',
							'7.51deg',
							'7.51deg',
							'6.94deg',
							'6.94deg',
							'6.93deg',
							'6.56deg',
							'6.56deg',
							'6.56deg',
							'6.24deg',
							'6.24deg',
							'6.24deg',
							'6.45deg',
							'6.45deg',
							'6.45deg',
							'6.93deg',
							'6.83deg',
							'6.83deg',
							'7.38deg',
							'7.38deg',
							'7.38deg',
							'7.77deg',
							'7.77deg',
							'7.77deg',
							'7.94deg',
							'7.94deg',
							'7.94deg',
							'8.04deg',
							'8.04deg',
							'8.04deg',
							'7.66deg',
							'7.66deg',
							'7.66deg',
							'7.16deg',
							'7.16deg',
							'7.16deg',
							'6.71deg',
							'6.71deg',
							'6.71deg',
							'6.53deg',
							'6.53deg',
							'6.53deg',
							'6.33deg',
							'6.33deg',
							'6.33deg',
							'6.48deg',
							'6.37deg',
							'6.47deg',
							'7.03deg',
							'6.93deg',
							'6.93deg',
							'7.52deg',
							'7.52deg',
							'7.52deg',
							'7.9deg',
							'7.89deg',
							'7.9deg',
							'8.02deg',
							'8.02deg',
							'8.02deg',
							'7.8deg',
							'7.8deg',
							'7.8deg',
							'7.52deg',
							'7.52deg',
							'7.52deg',
							'7.05deg',
							'7.05deg',
							'7.05deg',
							'6.58deg',
							'6.48deg',
							'6.48deg',
							'6.33deg',
							'6.43deg',
							'6.54deg',
							'6.36deg',
							'6.36deg',
							'6.36deg',
							'6.71deg',
							'6.71deg',
							'6.71deg',
							'7.08deg',
							'7.08deg',
							'7.08deg',
							'7.55deg',
							'7.55deg',
							'7.52deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'7.92deg',
							'7.92deg',
							'7.92deg',
							'7.27deg',
							'7.27deg',
							'7.27deg',
							'6.81deg',
							'6.81deg',
							'6.81deg',
							'6.36deg',
							'6.36deg',
							'6.36deg',
							'6.34deg',
							'6.36deg',
							'6.36deg',
							'6.59deg',
							'6.59deg',
							'6.59deg',
							'6.86deg',
							'6.86deg',
							'6.86deg',
							'7.55deg',
							'7.55deg',
							'7.50deg',
							'7.94deg',
							'7.94deg',
							'7.97deg',
							'8.00deg',
							'8.00deg',
							'8.00deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'7.72deg',
							'7.72deg',
							'7.72deg',
							'7.05deg',
							'7.05deg',
							'7.05deg',
							'6.57deg',
							'6.57deg',
							'6.57deg',
							'6.53deg',
							'6.53deg',
							'6.53deg',
							'6.16deg',
							'6.16deg',
							'6.16deg',
							'6.40deg',
							'6.40deg',
							'6.40deg',
							'7.05deg',
							'7.05deg',
							'7.44deg',
							'7.52deg',
							'7.52deg',
							'7.52deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'8.20deg',
							'8.20deg',
							'8.20deg',
							'7.75deg',
							'7.75deg',
							'7.75deg',
							'7.27deg',
							'7.27deg',
							'7.27deg',
							'7.01deg',
							'7.01deg',
							'7.01deg',
							'6.57deg',
							'6.55deg',
							'6.55deg',
							'6.34deg',
							'6.34deg',
							'6.34deg',
							'6.38deg',
							'6.38deg',
							'6.38deg',
							'7.01deg',
							'7.01deg',
							'7.05deg',
							'7.35deg',
							'7.35deg',
							'7.35deg',
							'7.80deg',
							'7.80deg',
							'7.80deg',
							'8.06deg',
							'8.06deg',
							'8.06deg',
							'8.00deg',
							'8.00deg',
							'7.80deg',
							'7.52deg',
							'7.52deg',
							'7.52deg',
							'7.05deg',
							'7.05deg',
							'7.05deg',
							'6.76deg',
							'6.74deg',
							'6.74deg',
							'6.34deg',
							'6.34deg',
							'6.34deg',
							'6.36deg',
							'6.36deg',
							'6.36deg',
							'6.57deg',
							'6.57deg',
							'6.57deg',
							'7.05deg',
							'7.05deg',
							'7.05deg',
							'7.52deg',
							'7.52deg',
							'7.52deg',
							'8.00deg',
							'8.00deg',
							'8.00deg',
							'8.23deg',
							'8.23deg',
							'8.23deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'7.52deg',
							'7.52deg',
							'7.52deg',
							'6.86deg',
							'6.83deg',
							'6.83deg',
							'6.57deg',
							'6.57deg',
							'6.57deg',
							'6.34deg',
							'6.34deg',
							'6.34deg',
							'6.36deg',
							'6.36deg',
							'6.36deg',
							'7.01deg',
							'7.01deg',
							'7.01deg',
							'7.27deg',
							'7.27deg',
							'7.27deg',
							'7.72deg',
							'7.92deg',
							'7.92deg',
							'7.83deg',
							'7.83deg',
							'7.83deg',
							'7.83deg',
							'7.83deg',
							'7.83deg',
							'7.52deg',
							'7.52deg',
							'7.72deg',
							'7.25deg',
							'7.25deg',
							'7.25deg',
							'6.59deg',
							'6.59deg',
							'6.59deg',
							'6.36deg',
							'6.36deg',
							'6.36deg',
							'6.53deg',
							'6.53deg',
							'6.53deg',
							'6.57deg',
							'6.57deg',
							'6.57deg',
							'7.03deg',
							'7.03deg',
							'7.03deg',
							'7.52deg',
							'7.52deg',
							'7.52deg',
							'8.00deg',
							'8.00deg',
							'8.00deg',
							'8.20deg',
							'8.20deg',
							'8.00deg',
							'8.17deg',
							'7.97deg',
							'7.97deg',
							'7.50deg',
							'7.55deg',
							'7.55deg',
							'7.05deg',
							'7.05deg',
							'7.05deg',
							'6.62deg',
							'6.62deg',
							'6.62deg',
							'6.36deg',
							'6.36deg',
							'6.34deg',
							'6.36deg',
							'6.36deg',
							'6.36deg',
							'6.79deg',
							'6.79deg',
							'6.79deg',
							'7.27deg',
							'7.27deg',
							'7.27deg',
							'7.75deg',
							'7.75deg',
							'7.75deg',
							'7.77deg',
							'7.77deg',
							'7.77deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'7.55deg',
							'7.55deg',
							'7.55deg',
							'7.05deg',
							'7.05deg',
							'7.05deg',
							'6.79deg',
							'6.79deg',
							'6.79deg',
							'6.74deg',
							'6.74deg',
							'6.55deg',
							'6.34deg',
							'6.34deg',
							'6.34deg',
							'6.57deg',
							'6.57deg',
							'6.57deg',
							'6.83deg',
							'6.83deg',
							'6.83deg',
							'7.52deg',
							'7.52deg',
							'7.32deg',
							'7.77deg',
							'7.77deg',
							'7.77deg',
							'8.00deg',
							'8.00deg',
							'8.00deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'7.72deg',
							'7.52deg',
							'7.52deg',
							'7.03deg',
							'7.03deg',
							'7.03deg',
							'6.59deg',
							'6.59deg',
							'6.62deg',
							'6.40deg',
							'6.40deg',
							'6.40deg',
							'6.57deg',
							'6.57deg',
							'6.57deg',
							'6.83deg',
							'6.83deg',
							'6.83deg',
							'7.05deg',
							'7.05deg',
							'7.05deg',
							'7.72deg',
							'7.72deg',
							'7.72deg',
							'7.97deg',
							'7.97deg',
							'7.97deg',
							'8.00deg',
							'8.00deg',
							'8.00deg',
							'7.75deg',
							'7.75deg',
							'7.75deg',
							'7.25deg',
							'7.25deg',
							'7.25deg',
							'6.62deg',
							'6.62deg',
							'6.62deg',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					scale: interpolate(
						frame,
						[
							0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
							19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
							35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
							51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66,
							67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82,
							83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98,
							99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111,
							112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
							125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
							138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150,
							151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163,
							164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176,
							177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
							190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202,
							203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215,
							216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228,
							229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241,
							242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254,
							255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267,
							268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280,
							281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293,
							294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306,
							307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319,
							320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332,
							333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345,
							346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358,
							359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371,
							372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384,
							385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397,
							398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410,
							411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423,
							424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436,
							437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449,
							450, 451, 452, 453, 454, 455,
						],
						[
							0.5274, 0.5274, 0.5272, 0.5396, 0.5396, 0.5396, 0.5933, 0.5929,
							0.5929, 0.6073, 0.6073, 0.6073, 0.6021, 0.6021, 0.6021, 0.5985,
							0.5985, 0.5983, 0.5996, 0.5996, 0.5996, 0.5938, 0.5938, 0.5938,
							0.5863, 0.5864, 0.5863, 0.5805, 0.5805, 0.5803, 0.5771, 0.5771,
							0.5771, 0.5767, 0.5771, 0.5762, 0.5812, 0.5812, 0.5816, 0.5911,
							0.5911, 0.5908, 0.5992, 0.5992, 0.5992, 0.6028, 0.6028, 0.6026,
							0.6007, 0.6007, 0.6007, 0.6012, 0.6012, 0.6012, 0.5906, 0.5906,
							0.5904, 0.5877, 0.5877, 0.5877, 0.5794, 0.5798, 0.5798, 0.5785,
							0.578, 0.5785, 0.5825, 0.5825, 0.5825, 0.5877, 0.5877, 0.5877,
							0.5929, 0.5929, 0.5931, 0.5998, 0.5998, 0.5998, 0.6016, 0.6016,
							0.6016, 0.6001, 0.6001, 0.6001, 0.5936, 0.5936, 0.5936, 0.5902,
							0.5902, 0.5897, 0.5837, 0.5837, 0.5837, 0.5789, 0.5789, 0.5787,
							0.5789, 0.5789, 0.5789, 0.5839, 0.5839, 0.5839, 0.5913, 0.5913,
							0.5909, 0.5953, 0.5953, 0.5953, 0.6026, 0.6023, 0.6023, 0.6028,
							0.6028, 0.6028, 0.598, 0.5987, 0.5989, 0.5938, 0.594, 0.5938,
							0.5868, 0.5868, 0.5868, 0.5816, 0.5819, 0.5814, 0.5805, 0.5805,
							0.5805, 0.581, 0.581, 0.581, 0.5868, 0.5866, 0.5868, 0.5918,
							0.5918, 0.5918, 0.5976, 0.5978, 0.5974, 0.6021, 0.6021, 0.6017,
							0.5996, 0.5999, 0.5999, 0.5954, 0.5956, 0.5956, 0.5894, 0.5894,
							0.5894, 0.5837, 0.5837, 0.5858, 0.5822, 0.5822, 0.5822, 0.5822,
							0.5822, 0.5822, 0.5864, 0.5864, 0.5864, 0.5897, 0.5897, 0.5897,
							0.5954, 0.5954, 0.5954, 0.6011, 0.6011, 0.6011, 0.6032, 0.6011,
							0.6011, 0.5972, 0.5972, 0.5972, 0.5912, 0.5912, 0.5912, 0.5837,
							0.5837, 0.5879, 0.5843, 0.5843, 0.5822, 0.5802, 0.5802, 0.5802,
							0.5822, 0.5822, 0.5822, 0.5861, 0.5861, 0.5861, 0.5915, 0.5915,
							0.5915, 0.5993, 0.5993, 0.5993, 0.6034, 0.6034, 0.6034, 0.6009,
							0.6009, 0.6009, 0.597, 0.597, 0.597, 0.5915, 0.5915, 0.592,
							0.5858, 0.5858, 0.5858, 0.5822, 0.5822, 0.5822, 0.5805, 0.5805,
							0.5805, 0.584, 0.584, 0.584, 0.5897, 0.5897, 0.5897, 0.5956,
							0.5956, 0.5956, 0.5993, 0.6013, 0.6013, 0.6032, 0.6032, 0.6032,
							0.599, 0.599, 0.599, 0.5956, 0.5956, 0.5915, 0.5835, 0.5835,
							0.5835, 0.5799, 0.5799, 0.5799, 0.5761, 0.5761, 0.5761, 0.5802,
							0.5802, 0.5799, 0.5858, 0.5858, 0.5858, 0.5915, 0.5915, 0.5915,
							0.5995, 0.6016, 0.6016, 0.6032, 0.6032, 0.6032, 0.6011, 0.6011,
							0.6011, 0.5993, 0.5993, 0.5993, 0.5915, 0.5915, 0.5915, 0.5858,
							0.5858, 0.5858, 0.5802, 0.5802, 0.5802, 0.5784, 0.5784, 0.5784,
							0.5822, 0.5822, 0.5822, 0.5858, 0.5858, 0.5858, 0.5912, 0.5933,
							0.5933, 0.5993, 0.5993, 0.5993, 0.6032, 0.6032, 0.6032, 0.6011,
							0.6011, 0.6011, 0.5956, 0.5956, 0.5956, 0.5897, 0.5897, 0.5897,
							0.5861, 0.5864, 0.5864, 0.5778, 0.5778, 0.5778, 0.5778, 0.5778,
							0.5778, 0.5858, 0.5858, 0.5861, 0.5917, 0.5917, 0.5917, 0.5972,
							0.5972, 0.5972, 0.6011, 0.6011, 0.6011, 0.6034, 0.6034, 0.6034,
							0.5993, 0.5993, 0.5993, 0.5936, 0.5936, 0.5936, 0.5858, 0.5858,
							0.5858, 0.5802, 0.5802, 0.5802, 0.5805, 0.5805, 0.5802, 0.5825,
							0.5822, 0.5822, 0.5879, 0.5837, 0.5837, 0.5915, 0.5915, 0.5915,
							0.5951, 0.5951, 0.5951, 0.6011, 0.6011, 0.6032, 0.6011, 0.6011,
							0.6011, 0.5974, 0.5974, 0.5974, 0.5897, 0.5897, 0.5897, 0.584,
							0.584, 0.584, 0.582, 0.582, 0.582, 0.5822, 0.5822, 0.5822, 0.5837,
							0.5837, 0.5837, 0.5915, 0.5915, 0.5915, 0.5974, 0.5974, 0.5974,
							0.6016, 0.6016, 0.6013, 0.6032, 0.6032, 0.6032, 0.5993, 0.5993,
							0.5993, 0.5933, 0.5933, 0.5933, 0.5858, 0.5858, 0.5855, 0.582,
							0.582, 0.582, 0.5802, 0.5802, 0.5802, 0.5822, 0.5822, 0.5822,
							0.5861, 0.5858, 0.5858, 0.5936, 0.5936, 0.5936, 0.5972, 0.5972,
							0.5951, 0.597, 0.597, 0.597, 0.5993, 0.5993, 0.5993, 0.5933,
							0.5933, 0.5933, 0.5915, 0.5915, 0.5915, 0.5861, 0.5861, 0.5861,
							0.5822, 0.5822, 0.5822, 0.5802, 0.5802, 0.5802, 0.584, 0.584,
							0.584, 0.5917, 0.5917, 0.5917, 0.5951, 0.5951, 0.5951,
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
							output: 'perceptual-scale',
						},
					),
				}}
			>
				<Skills2Announcement title="/remotion-best-practices" />
			</Sequence>
			<Sequence
				name="Remotion markup"
				width={1071}
				height={102}
				durationInFrames={456}
				style={{
					position: 'absolute',
					translate: interpolate(
						frame,
						[
							7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
							24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
							40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
							56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
							72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
							88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
							116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128,
							129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141,
							142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154,
							155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167,
							168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180,
							181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
							194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206,
							207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219,
							220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
							233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245,
							246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258,
							259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271,
							272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284,
							285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297,
							298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310,
							311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323,
							324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336,
							337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349,
							350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362,
							363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375,
							376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388,
							389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401,
							402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414,
							415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427,
							428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440,
							441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453,
							454, 455,
						],
						[
							'245.6px 422px',
							'235.9px 525.3px',
							'215.3px 575.9px',
							'226.3px 665.6px',
							'224.5px 761.7px',
							'227.3px 859px',
							'224.2px 943.9px',
							'222.3px 1016.7px',
							'228.2px 1017.2px',
							'225.6px 1016.1px',
							'233.7px 1014.2px',
							'241.6px 1015.6px',
							'247.5px 1011.7px',
							'256.5px 1011.6px',
							'262.7px 1010px',
							'268px 1011.4px',
							'273.6px 1013px',
							'276.9px 1014.4px',
							'269.4px 1017.7px',
							'271.4px 1017.5px',
							'272.5px 1016.4px',
							'273.1px 1016.4px',
							'274px 1016.7px',
							'278.4px 1012.3px',
							'276.5px 1012.4px',
							'277.3px 1011.6px',
							'276.9px 1013.9px',
							'273.7px 1013px',
							'268.1px 1014.6px',
							'265.9px 1014.6px',
							'263.1px 1014.6px',
							'259.9px 1014.6px',
							'257.1px 1014.6px',
							'253.7px 1014.6px',
							'250.2px 1014.6px',
							'247.3px 1014.6px',
							'244.1px 1014.7px',
							'241.3px 1014.7px',
							'243.5px 1014.6px',
							'242.1px 1014.6px',
							'241.4px 1014.6px',
							'241.7px 1014.6px',
							'242.3px 1014.6px',
							'242.5px 1014.6px',
							'242.0px 1014.6px',
							'241.5px 1014.6px',
							'240.8px 1014.6px',
							'239.0px 1014.6px',
							'240.0px 1016.0px',
							'238.8px 1016.0px',
							'236.6px 1016.0px',
							'235.0px 1016.0px',
							'233.4px 1016.0px',
							'231.0px 1016.1px',
							'229.0px 1016.1px',
							'226.9px 1016.1px',
							'224.8px 1016.1px',
							'222.6px 1016.1px',
							'219.6px 1016.1px',
							'217.4px 1016.1px',
							'215.3px 1016.1px',
							'213.4px 1016.1px',
							'212.1px 1016.1px',
							'210.4px 1016.1px',
							'208.9px 1016.1px',
							'208.2px 1016.1px',
							'205.8px 1015.8px',
							'203.4px 1015.5px',
							'201.1px 1015.2px',
							'198.7px 1015.0px',
							'196.3px 1014.7px',
							'193.9px 1014.4px',
							'194.3px 1014.4px',
							'194.5px 1014.5px',
							'194.1px 1014.4px',
							'193.7px 1014.4px',
							'193.3px 1014.4px',
							'192.0px 1014.4px',
							'196.5px 1014.6px',
							'195.7px 1014.6px',
							'193.9px 1014.6px',
							'193.2px 1014.6px',
							'192.6px 1014.6px',
							'191.3px 1014.5px',
							'191.1px 1014.5px',
							'191.1px 1014.5px',
							'190.3px 1014.4px',
							'189.5px 1014.3px',
							'188.7px 1014.2px',
							'187.9px 1014.2px',
							'187.1px 1014.1px',
							'186.3px 1014.0px',
							'188.8px 1014.1px',
							'191.3px 1014.2px',
							'194.4px 1012.8px',
							'198.2px 1012.9px',
							'201.6px 1013.0px',
							'205.3px 1013.0px',
							'214.9px 1013.2px',
							'218.5px 1013.2px',
							'222.3px 1013.3px',
							'226.6px 1013.3px',
							'230.9px 1013.3px',
							'235.8px 1013.3px',
							'241.0px 1014.6px',
							'246.3px 1014.6px',
							'251.5px 1014.5px',
							'256.6px 1014.5px',
							'263.5px 1017.1px',
							'269.0px 1015.5px',
							'273.4px 1015.5px',
							'278.3px 1015.4px',
							'282.8px 1015.2px',
							'286.2px 1015.2px',
							'289.7px 1015.1px',
							'292.6px 1015.0px',
							'294.4px 1015.0px',
							'296.3px 1014.9px',
							'302.2px 1013.1px',
							'302.6px 1013.1px',
							'302.8px 1013.1px',
							'302.6px 1013.1px',
							'302.0px 1013.1px',
							'301.1px 1013.1px',
							'299.8px 1013.1px',
							'298.6px 1013.1px',
							'295.6px 1013.5px',
							'292.5px 1013.9px',
							'289.5px 1014.3px',
							'286.4px 1014.7px',
							'283.4px 1015.1px',
							'280.3px 1015.5px',
							'278.4px 1015.6px',
							'275.7px 1015.6px',
							'272.6px 1015.7px',
							'268.6px 1015.7px',
							'264.1px 1014.4px',
							'259.2px 1014.5px',
							'263.0px 1012.6px',
							'257.5px 1012.7px',
							'251.5px 1012.8px',
							'246.1px 1014.3px',
							'240.5px 1014.4px',
							'234.3px 1014.5px',
							'229.6px 1014.2px',
							'224.9px 1014.0px',
							'220.2px 1013.7px',
							'215.5px 1013.5px',
							'210.8px 1013.2px',
							'206.1px 1013.0px',
							'201.4px 1012.7px',
							'196.8px 1012.5px',
							'192.1px 1012.2px',
							'187.4px 1012.0px',
							'186.5px 1012.0px',
							'186.3px 1012.0px',
							'186.9px 1012.5px',
							'188.5px 1013.4px',
							'190.8px 1014.8px',
							'193.1px 1015.8px',
							'195.2px 1016.2px',
							'196.9px 1016.3px',
							'198.4px 1016.3px',
							'199.5px 1016.3px',
							'200.5px 1016.3px',
							'201.0px 1016.3px',
							'201.8px 1016.0px',
							'202.4px 1015.4px',
							'203.1px 1014.5px',
							'202.8px 1013.9px',
							'201.9px 1013.6px',
							'200.1px 1013.6px',
							'198.2px 1013.6px',
							'195.8px 1013.6px',
							'193.3px 1013.6px',
							'190.3px 1013.5px',
							'187.7px 1013.5px',
							'185.1px 1013.5px',
							'182.9px 1013.5px',
							'180.2px 1013.4px',
							'177.4px 1013.4px',
							'174.4px 1013.3px',
							'171.5px 1013.3px',
							'168.7px 1013.2px',
							'166.3px 1013.2px',
							'164.0px 1013.1px',
							'163.2px 1013.2px',
							'163.8px 1013.3px',
							'165.9px 1013.4px',
							'167.5px 1013.5px',
							'168.7px 1013.5px',
							'169.5px 1013.5px',
							'170.5px 1013.5px',
							'171.6px 1013.6px',
							'172.7px 1013.6px',
							'173.8px 1013.6px',
							'174.0px 1013.6px',
							'173.3px 1013.5px',
							'171.6px 1013.4px',
							'170.7px 1013.4px',
							'170.7px 1013.3px',
							'171.4px 1013.3px',
							'172.1px 1013.3px',
							'172.5px 1013.3px',
							'173.0px 1013.3px',
							'173.3px 1013.3px',
							'173.9px 1013.7px',
							'174.7px 1014.3px',
							'175.8px 1015.2px',
							'176.6px 1015.9px',
							'177.2px 1016.2px',
							'177.5px 1016.2px',
							'177.7px 1016.2px',
							'178.0px 1016.2px',
							'178.2px 1016.2px',
							'178.6px 1016.2px',
							'179.2px 1015.7px',
							'180.0px 1014.8px',
							'180.7px 1013.5px',
							'181.4px 1012.6px',
							'181.9px 1012.2px',
							'182.4px 1012.2px',
							'183.0px 1012.2px',
							'183.8px 1012.2px',
							'184.4px 1012.2px',
							'184.8px 1012.2px',
							'184.5px 1012.4px',
							'183.5px 1012.6px',
							'181.8px 1013.0px',
							'180.6px 1013.3px',
							'180.0px 1013.4px',
							'179.9px 1013.4px',
							'179.9px 1013.4px',
							'180.2px 1013.4px',
							'180.6px 1013.4px',
							'180.9px 1013.4px',
							'181.6px 1013.7px',
							'183.0px 1014.4px',
							'185.3px 1015.3px',
							'187.2px 1016.0px',
							'188.6px 1016.3px',
							'189.5px 1016.3px',
							'190.4px 1016.3px',
							'191.7px 1016.3px',
							'192.9px 1016.3px',
							'194.3px 1016.3px',
							'194.5px 1015.9px',
							'193.5px 1014.9px',
							'191.4px 1013.5px',
							'190.7px 1012.5px',
							'191.2px 1012.1px',
							'193.1px 1012.1px',
							'194.6px 1012.1px',
							'196.4px 1012.2px',
							'198.3px 1012.2px',
							'200.4px 1012.2px',
							'204.1px 1012.6px',
							'209.4px 1013.2px',
							'216.3px 1014.1px',
							'221.7px 1014.6px',
							'225.4px 1014.9px',
							'227.2px 1014.9px',
							'228.8px 1014.8px',
							'230.4px 1014.8px',
							'232.3px 1014.8px',
							'234.4px 1014.8px',
							'237.0px 1014.6px',
							'239.8px 1014.3px',
							'242.9px 1013.8px',
							'245.5px 1013.5px',
							'247.7px 1013.3px',
							'249.6px 1013.3px',
							'251.7px 1013.3px',
							'254.0px 1013.2px',
							'256.1px 1013.2px',
							'258.2px 1013.2px',
							'259.4px 1013.2px',
							'260.0px 1013.2px',
							'259.8px 1013.3px',
							'260.4px 1013.3px',
							'261.7px 1013.3px',
							'264.0px 1013.2px',
							'266.8px 1013.2px',
							'270.3px 1013.1px',
							'274.5px 1013.0px',
							'279.1px 1012.9px',
							'284.3px 1012.9px',
							'289.8px 1013.0px',
							'295.8px 1013.2px',
							'301.3px 1013.3px',
							'305.9px 1013.3px',
							'309.7px 1013.1px',
							'312.7px 1013.0px',
							'315.3px 1012.9px',
							'317.0px 1012.8px',
							'317.9px 1012.8px',
							'317.2px 1013.0px',
							'315.0px 1013.5px',
							'311.4px 1014.2px',
							'307.9px 1014.7px',
							'304.6px 1015.0px',
							'301.3px 1015.0px',
							'297.4px 1014.8px',
							'292.8px 1014.5px',
							'287.5px 1014.4px',
							'281.8px 1014.4px',
							'276.1px 1014.7px',
							'270.7px 1015.1px',
							'265.7px 1015.6px',
							'261.0px 1015.9px',
							'256.4px 1016.1px',
							'252.0px 1016.1px',
							'247.9px 1016.1px',
							'244.0px 1016.1px',
							'240.6px 1016.2px',
							'237.5px 1016.2px',
							'235.0px 1016.0px',
							'233.1px 1015.7px',
							'231.9px 1015.3px',
							'231.2px 1015.0px',
							'230.8px 1014.8px',
							'230.8px 1014.8px',
							'231.4px 1014.8px',
							'232.5px 1014.8px',
							'234.3px 1014.8px',
							'236.6px 1014.8px',
							'238.1px 1014.8px',
							'238.7px 1014.8px',
							'238.3px 1014.9px',
							'239.3px 1014.9px',
							'241.8px 1014.9px',
							'245.8px 1014.9px',
							'250.0px 1014.9px',
							'254.2px 1014.9px',
							'258.2px 1014.8px',
							'261.9px 1014.8px',
							'266.9px 1014.4px',
							'272.9px 1013.6px',
							'279.8px 1012.4px',
							'284.5px 1011.6px',
							'286.8px 1011.2px',
							'286.5px 1011.2px',
							'284.9px 1011.2px',
							'282.0px 1011.3px',
							'277.8px 1011.4px',
							'272.4px 1011.5px',
							'265.6px 1011.7px',
							'258.1px 1011.9px',
							'250.0px 1012.0px',
							'242.1px 1012.1px',
							'233.9px 1012.2px',
							'225.5px 1012.3px',
							'216.7px 1012.3px',
							'208.1px 1012.3px',
							'199.5px 1012.3px',
							'191.2px 1012.3px',
							'183.4px 1012.8px',
							'176.3px 1013.9px',
							'170.2px 1015.6px',
							'164.6px 1016.7px',
							'159.6px 1017.1px',
							'155.2px 1016.7px',
							'151.5px 1016.2px',
							'148.7px 1015.8px',
							'147.1px 1015.6px',
							'146.6px 1015.6px',
							'146.9px 1015.0px',
							'147.7px 1013.8px',
							'149.1px 1012.0px',
							'152.1px 1010.8px',
							'156.6px 1010.3px',
							'161.8px 1010.4px',
							'166.8px 1010.5px',
							'171.2px 1010.6px',
							'175.0px 1010.7px',
							'178.4px 1010.7px',
							'181.5px 1011.1px',
							'183.9px 1011.7px',
							'185.9px 1012.6px',
							'187.6px 1013.3px',
							'189.2px 1013.6px',
							'190.4px 1013.6px',
							'190.9px 1013.6px',
							'191.0px 1013.6px',
							'191.3px 1013.6px',
							'191.8px 1013.6px',
							'192.6px 1013.9px',
							'193.3px 1014.5px',
							'193.9px 1015.4px',
							'194.2px 1016.0px',
							'194.3px 1016.3px',
							'194.3px 1016.3px',
							'194.2px 1016.3px',
							'194.4px 1016.3px',
							'194.9px 1016.3px',
							'196.0px 1016.3px',
							'196.7px 1015.9px',
							'197.1px 1015.0px',
							'196.8px 1013.6px',
							'197.7px 1012.7px',
							'200.0px 1012.3px',
							'203.6px 1012.3px',
							'207.4px 1012.3px',
							'211.0px 1012.3px',
							'214.3px 1012.3px',
							'217.1px 1012.3px',
							'218.7px 1012.8px',
							'219.1px 1013.7px',
							'218.7px 1015.0px',
							'218.9px 1015.9px',
							'219.6px 1016.3px',
							'220.4px 1016.3px',
							'220.5px 1016.3px',
							'220.3px 1016.3px',
							'219.8px 1016.3px',
							'219.0px 1016.3px',
							'219.0px 1015.9px',
							'220.3px 1015.0px',
							'222.9px 1013.6px',
							'224.2px 1012.7px',
							'224.4px 1012.2px',
							'222.9px 1012.2px',
							'221.1px 1012.2px',
							'218.9px 1012.2px',
							'216.6px 1012.3px',
							'214.1px 1012.3px',
							'211.4px 1012.6px',
							'208.5px 1013.2px',
							'205.6px 1014.1px',
							'204.0px 1014.6px',
							'203.9px 1014.9px',
							'204.8px 1014.9px',
							'205.8px 1014.9px',
							'206.2px 1014.9px',
							'206.3px 1014.9px',
							'206.1px 1014.9px',
							'207.2px 1015.1px',
							'209.5px 1015.4px',
							'213.2px 1015.9px',
							'215.5px 1016.1px',
							'216.3px 1016.3px',
							'215.7px 1016.2px',
							'215.0px 1016.3px',
							'214.4px 1016.2px',
							'214.0px 1016.2px',
							'213.6px 1016.2px',
							'212.7px 1015.8px',
							'211.0px 1014.9px',
							'208.8px 1013.6px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					scale: interpolate(frame, [7], [0.446], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					}),
					rotate: interpolate(
						frame,
						[
							7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
							24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
							40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
							56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
							72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
							88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
							116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128,
							129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141,
							142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154,
							155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167,
							168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180,
							181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
							194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206,
							207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219,
							220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
							233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245,
							246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258,
							259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271,
							272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284,
							285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297,
							298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310,
							311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323,
							324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336,
							337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349,
							350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362,
							363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375,
							376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388,
							389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401,
							402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414,
							415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427,
							428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440,
							441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453,
							454, 455,
						],
						[
							'85.4deg',
							'87.9deg',
							'90deg',
							'87.9deg',
							'88.7deg',
							'89.8deg',
							'90deg',
							'90deg',
							'90.1deg',
							'90.8deg',
							'90deg',
							'88.2deg',
							'87.9deg',
							'87.1deg',
							'86.4deg',
							'85.8deg',
							'85deg',
							'84.8deg',
							'87.3deg',
							'87deg',
							'87deg',
							'87deg',
							'86.9deg',
							'86.8deg',
							'87.2deg',
							'86.7deg',
							'87deg',
							'87.1deg',
							'88.1deg',
							'88.2deg',
							'88.3deg',
							'88.5deg',
							'88.6deg',
							'88.8deg',
							'89.1deg',
							'89.1deg',
							'89.4deg',
							'89.6deg',
							'88.7deg',
							'88.8deg',
							'88.8deg',
							'88.8deg',
							'88.8deg',
							'88.8deg',
							'88.9deg',
							'88.9deg',
							'88.9deg',
							'89.2deg',
							'88.9deg',
							'88.9deg',
							'89.1deg',
							'89.1deg',
							'89.1deg',
							'89.3deg',
							'89.3deg',
							'89.4deg',
							'89.5deg',
							'89.5deg',
							'89.6deg',
							'89.7deg',
							'89.8deg',
							'89.9deg',
							'89.8deg',
							'89.9deg',
							'90.0deg',
							'89.8deg',
							'90.3deg',
							'90.8deg',
							'91.2deg',
							'91.7deg',
							'92.2deg',
							'92.7deg',
							'92.6deg',
							'92.6deg',
							'92.7deg',
							'92.7deg',
							'92.7deg',
							'92.9deg',
							'91.2deg',
							'91.3deg',
							'91.6deg',
							'91.6deg',
							'91.7deg',
							'91.9deg',
							'91.9deg',
							'91.9deg',
							'92.3deg',
							'92.7deg',
							'93.2deg',
							'93.6deg',
							'94.0deg',
							'94.4deg',
							'94.2deg',
							'93.9deg',
							'93.7deg',
							'93.3deg',
							'93.0deg',
							'92.6deg',
							'91.2deg',
							'90.9deg',
							'90.6deg',
							'90.1deg',
							'89.8deg',
							'89.3deg',
							'88.9deg',
							'88.4deg',
							'88.0deg',
							'87.7deg',
							'86.4deg',
							'85.9deg',
							'85.7deg',
							'85.3deg',
							'84.9deg',
							'84.7deg',
							'84.4deg',
							'84.2deg',
							'84.1deg',
							'84.0deg',
							'82.9deg',
							'82.9deg',
							'82.9deg',
							'82.9deg',
							'82.9deg',
							'83.0deg',
							'83.0deg',
							'83.0deg',
							'83.5deg',
							'84.0deg',
							'84.5deg',
							'85.0deg',
							'85.5deg',
							'86.0deg',
							'86.1deg',
							'86.3deg',
							'86.5deg',
							'86.8deg',
							'87.1deg',
							'87.4deg',
							'85.4deg',
							'85.8deg',
							'86.4deg',
							'86.7deg',
							'87.2deg',
							'87.8deg',
							'88.3deg',
							'88.9deg',
							'89.4deg',
							'89.9deg',
							'90.5deg',
							'91.0deg',
							'91.5deg',
							'92.1deg',
							'92.6deg',
							'93.1deg',
							'93.1deg',
							'93.1deg',
							'92.9deg',
							'92.6deg',
							'92.2deg',
							'91.9deg',
							'91.6deg',
							'91.4deg',
							'91.3deg',
							'91.2deg',
							'91.2deg',
							'91.1deg',
							'91.0deg',
							'90.9deg',
							'90.8deg',
							'90.8deg',
							'90.8deg',
							'91.0deg',
							'91.2deg',
							'91.5deg',
							'91.7deg',
							'92.0deg',
							'92.2deg',
							'92.3deg',
							'92.4deg',
							'92.6deg',
							'92.8deg',
							'93.0deg',
							'93.3deg',
							'93.5deg',
							'93.7deg',
							'93.9deg',
							'93.8deg',
							'93.4deg',
							'92.8deg',
							'92.3deg',
							'92.0deg',
							'91.9deg',
							'91.8deg',
							'91.7deg',
							'91.6deg',
							'91.5deg',
							'91.6deg',
							'91.9deg',
							'92.5deg',
							'92.9deg',
							'93.0deg',
							'93.0deg',
							'93.0deg',
							'93.0deg',
							'93.0deg',
							'93.0deg',
							'92.9deg',
							'92.7deg',
							'92.5deg',
							'92.3deg',
							'92.2deg',
							'92.2deg',
							'92.2deg',
							'92.2deg',
							'92.2deg',
							'92.2deg',
							'92.2deg',
							'92.1deg',
							'92.1deg',
							'92.0deg',
							'92.0deg',
							'91.9deg',
							'91.8deg',
							'91.7deg',
							'91.7deg',
							'91.6deg',
							'91.7deg',
							'91.9deg',
							'92.3deg',
							'92.6deg',
							'92.8deg',
							'92.8deg',
							'92.9deg',
							'92.9deg',
							'92.9deg',
							'92.9deg',
							'92.7deg',
							'92.3deg',
							'91.7deg',
							'91.2deg',
							'91.0deg',
							'90.9deg',
							'90.9deg',
							'90.8deg',
							'90.8deg',
							'90.7deg',
							'90.8deg',
							'91.3deg',
							'92.1deg',
							'92.5deg',
							'92.6deg',
							'92.4deg',
							'92.3deg',
							'92.1deg',
							'91.9deg',
							'91.7deg',
							'91.2deg',
							'90.5deg',
							'89.4deg',
							'88.6deg',
							'88.1deg',
							'88.0deg',
							'87.9deg',
							'87.9deg',
							'87.8deg',
							'87.6deg',
							'87.4deg',
							'87.2deg',
							'87.0deg',
							'86.9deg',
							'86.9deg',
							'86.8deg',
							'86.7deg',
							'86.5deg',
							'86.4deg',
							'86.3deg',
							'86.3deg',
							'86.5deg',
							'86.7deg',
							'86.8deg',
							'86.7deg',
							'86.5deg',
							'86.3deg',
							'86.0deg',
							'85.6deg',
							'85.2deg',
							'84.8deg',
							'84.3deg',
							'83.8deg',
							'83.3deg',
							'82.9deg',
							'82.6deg',
							'82.4deg',
							'82.2deg',
							'82.0deg',
							'82.0deg',
							'82.1deg',
							'82.5deg',
							'83.0deg',
							'83.5deg',
							'83.9deg',
							'84.1deg',
							'84.4deg',
							'84.8deg',
							'85.3deg',
							'85.8deg',
							'86.3deg',
							'86.7deg',
							'86.9deg',
							'87.1deg',
							'87.2deg',
							'87.4deg',
							'87.5deg',
							'87.6deg',
							'87.7deg',
							'87.8deg',
							'87.8deg',
							'87.9deg',
							'87.9deg',
							'87.9deg',
							'87.8deg',
							'87.8deg',
							'87.8deg',
							'87.7deg',
							'87.6deg',
							'87.4deg',
							'87.4deg',
							'87.7deg',
							'88.3deg',
							'88.7deg',
							'88.8deg',
							'88.6deg',
							'88.3deg',
							'88.1deg',
							'87.9deg',
							'87.7deg',
							'87.2deg',
							'86.4deg',
							'85.3deg',
							'84.6deg',
							'84.3deg',
							'84.3deg',
							'84.4deg',
							'84.6deg',
							'84.9deg',
							'85.2deg',
							'85.7deg',
							'86.3deg',
							'87.0deg',
							'87.6deg',
							'88.2deg',
							'88.7deg',
							'89.4deg',
							'90.0deg',
							'90.7deg',
							'91.3deg',
							'91.9deg',
							'92.4deg',
							'92.8deg',
							'93.2deg',
							'93.6deg',
							'93.9deg',
							'94.2deg',
							'94.5deg',
							'94.6deg',
							'94.7deg',
							'94.8deg',
							'94.8deg',
							'94.8deg',
							'94.7deg',
							'94.4deg',
							'94.0deg',
							'93.6deg',
							'93.3deg',
							'93.0deg',
							'92.8deg',
							'92.5deg',
							'92.2deg',
							'91.9deg',
							'91.6deg',
							'91.4deg',
							'91.3deg',
							'91.3deg',
							'91.4deg',
							'91.3deg',
							'91.2deg',
							'90.9deg',
							'90.7deg',
							'90.4deg',
							'90.3deg',
							'90.2deg',
							'90.2deg',
							'90.2deg',
							'90.2deg',
							'90.2deg',
							'90.2deg',
							'90.3deg',
							'90.5deg',
							'90.9deg',
							'91.1deg',
							'91.2deg',
							'91.0deg',
							'90.8deg',
							'90.7deg',
							'90.5deg',
							'90.3deg',
							'90.3deg',
							'90.4deg',
							'90.6deg',
							'90.7deg',
							'90.6deg',
							'90.5deg',
							'90.5deg',
							'90.5deg',
							'90.5deg',
							'90.5deg',
							'90.3deg',
							'89.9deg',
							'89.1deg',
							'88.6deg',
							'88.4deg',
							'88.4deg',
							'88.4deg',
							'88.6deg',
							'88.8deg',
							'89.1deg',
							'89.5deg',
							'90.1deg',
							'90.8deg',
							'91.2deg',
							'91.4deg',
							'91.3deg',
							'91.2deg',
							'91.3deg',
							'91.3deg',
							'91.4deg',
							'91.1deg',
							'90.5deg',
							'89.5deg',
							'88.8deg',
							'88.4deg',
							'88.4deg',
							'88.5deg',
							'88.4deg',
							'88.4deg',
							'88.3deg',
							'88.5deg',
							'88.8deg',
							'89.2deg',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			>
				<Skills2Announcement
					title="/remotion-markup"
					revealScale={interpolate(frame, [7, 14], [0, 1], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					})}
				/>
			</Sequence>
			<Sequence
				name="Remotion maps"
				width={1071}
				height={102}
				durationInFrames={456}
				style={{
					position: 'absolute',
					translate: interpolate(
						frame,
						[
							7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
							24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
							40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
							56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
							72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
							88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
							116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128,
							129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141,
							142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154,
							155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167,
							168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180,
							181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
							194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206,
							207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219,
							220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
							233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245,
							246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258,
							259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271,
							272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284,
							285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297,
							298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310,
							311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323,
							324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336,
							337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349,
							350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362,
							363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375,
							376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388,
							389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401,
							402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414,
							415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427,
							428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440,
							441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453,
							454, 455,
						],
						[
							'278.6px 459.2px',
							'281.4px 585.8px',
							'290.6px 659.9px',
							'294.4px 762.6px',
							'293.7px 865.7px',
							'308.6px 961.2px',
							'309.6px 992.9px',
							'307.8px 995.7px',
							'325px 993.7px',
							'322.7px 992.6px',
							'325.3px 990.7px',
							'323.4px 992px',
							'324.9px 989.5px',
							'326.8px 989.5px',
							'326px 988.1px',
							'324.9px 989.6px',
							'325.5px 991.5px',
							'326.2px 992.9px',
							'302.9px 997.2px',
							'303.2px 997.1px',
							'304.9px 995.9px',
							'302.6px 995.9px',
							'306.4px 996.2px',
							'310px 992px',
							'310px 991.9px',
							'314.9px 991.1px',
							'317.7px 993.4px',
							'315px 992.6px',
							'315.7px 995.5px',
							'317.2px 995.4px',
							'319.0px 995.4px',
							'320.8px 995.4px',
							'322.3px 995.4px',
							'324.1px 995.4px',
							'325.9px 995.4px',
							'327.5px 995.4px',
							'329.1px 995.3px',
							'330.6px 995.3px',
							'336.6px 992.2px',
							'337.8px 992.2px',
							'338.8px 992.1px',
							'339.7px 992.1px',
							'340.5px 992.1px',
							'341.3px 992.1px',
							'342.3px 992.1px',
							'342.9px 992.0px',
							'343.6px 992.0px',
							'344.5px 992.0px',
							'343.1px 995.1px',
							'343.6px 995.1px',
							'344.3px 995.1px',
							'344.7px 995.1px',
							'345.1px 995.1px',
							'345.9px 995.1px',
							'346.2px 995.1px',
							'346.6px 995.1px',
							'347.1px 995.1px',
							'347.5px 995.0px',
							'354.2px 996.0px',
							'354.6px 996.0px',
							'355.0px 996.0px',
							'355.4px 996.0px',
							'355.6px 996.0px',
							'356.2px 996.0px',
							'356.6px 996.0px',
							'357.0px 996.0px',
							'357.6px 996.0px',
							'358.2px 996.0px',
							'359.1px 994.3px',
							'360.0px 994.3px',
							'361.0px 994.3px',
							'362.0px 994.2px',
							'363.4px 994.2px',
							'364.9px 994.1px',
							'366.7px 994.1px',
							'368.5px 994.0px',
							'370.4px 993.9px',
							'372.5px 993.8px',
							'368.4px 990.4px',
							'369.9px 990.4px',
							'371.7px 990.3px',
							'373.0px 990.3px',
							'374.1px 990.3px',
							'375.4px 990.3px',
							'376.2px 990.2px',
							'376.9px 990.2px',
							'378.6px 991.0px',
							'380.3px 991.7px',
							'382.0px 992.5px',
							'383.8px 993.2px',
							'385.5px 994.0px',
							'387.2px 994.7px',
							'386.3px 994.7px',
							'385.6px 994.7px',
							'384.5px 994.8px',
							'383.1px 994.9px',
							'381.9px 994.9px',
							'380.6px 995.0px',
							'385.0px 992.6px',
							'383.9px 992.6px',
							'382.7px 992.7px',
							'381.3px 992.8px',
							'380.0px 992.8px',
							'378.6px 992.9px',
							'377.0px 992.9px',
							'375.4px 993.0px',
							'372.7px 993.0px',
							'370.0px 993.0px',
							'367.3px 993.0px',
							'364.6px 993.0px',
							'361.9px 993.0px',
							'359.2px 993.0px',
							'358.6px 993.0px',
							'358.5px 992.9px',
							'358.2px 992.9px',
							'358.0px 992.9px',
							'358.3px 992.9px',
							'358.5px 992.9px',
							'358.2px 992.9px',
							'358.9px 992.8px',
							'359.9px 992.8px',
							'361.0px 992.8px',
							'362.1px 992.8px',
							'363.6px 992.7px',
							'365.1px 992.7px',
							'366.4px 992.7px',
							'368.0px 992.6px',
							'369.6px 992.6px',
							'368.0px 995.9px',
							'369.2px 995.8px',
							'370.3px 995.8px',
							'371.0px 995.8px',
							'371.7px 995.8px',
							'372.2px 995.8px',
							'372.4px 995.8px',
							'372.5px 995.8px',
							'372.5px 995.8px',
							'372.3px 995.8px',
							'372.7px 994.5px',
							'372.2px 994.5px',
							'371.9px 994.5px',
							'371.1px 994.5px',
							'370.3px 994.5px',
							'369.7px 994.5px',
							'368.6px 994.1px',
							'367.5px 993.8px',
							'366.4px 993.4px',
							'365.3px 993.1px',
							'364.1px 992.7px',
							'363.0px 992.4px',
							'361.9px 992.0px',
							'360.8px 991.6px',
							'359.7px 991.3px',
							'358.6px 990.9px',
							'357.7px 991.0px',
							'357.1px 991.0px',
							'356.0px 991.3px',
							'354.6px 992.0px',
							'352.9px 993.1px',
							'352.0px 993.8px',
							'351.9px 994.1px',
							'352.7px 994.1px',
							'353.6px 994.1px',
							'354.7px 994.1px',
							'355.7px 994.1px',
							'356.9px 994.0px',
							'358.7px 994.1px',
							'360.8px 994.3px',
							'363.3px 994.6px',
							'365.1px 994.7px',
							'366.3px 994.8px',
							'366.7px 994.8px',
							'366.8px 994.8px',
							'366.5px 994.8px',
							'365.9px 994.8px',
							'364.9px 994.8px',
							'363.7px 994.3px',
							'362.4px 993.6px',
							'361.0px 992.5px',
							'359.1px 992.1px',
							'356.7px 992.0px',
							'354.2px 992.2px',
							'351.7px 992.3px',
							'349.0px 992.4px',
							'346.1px 992.4px',
							'342.9px 992.5px',
							'339.2px 992.9px',
							'335.2px 993.7px',
							'331.0px 994.7px',
							'327.6px 995.5px',
							'324.8px 995.8px',
							'322.5px 995.9px',
							'320.3px 995.9px',
							'318.1px 995.9px',
							'316.3px 995.9px',
							'314.8px 995.9px',
							'313.9px 995.8px',
							'313.3px 995.5px',
							'313.1px 995.0px',
							'312.8px 994.6px',
							'312.3px 994.5px',
							'311.8px 994.5px',
							'311.4px 994.5px',
							'311.1px 994.5px',
							'310.9px 994.5px',
							'311.0px 994.5px',
							'311.5px 994.5px',
							'312.3px 994.4px',
							'313.4px 994.4px',
							'314.4px 994.4px',
							'315.1px 994.4px',
							'315.9px 994.4px',
							'316.5px 994.4px',
							'317.2px 994.4px',
							'317.7px 994.4px',
							'318.2px 994.4px',
							'319.2px 994.0px',
							'320.5px 993.3px',
							'322.0px 992.3px',
							'322.7px 991.6px',
							'322.7px 991.3px',
							'322.1px 991.3px',
							'321.6px 991.3px',
							'321.3px 991.3px',
							'321.3px 991.3px',
							'321.3px 991.3px',
							'321.4px 992.0px',
							'321.6px 993.3px',
							'322.0px 995.2px',
							'322.7px 996.5px',
							'323.6px 997.2px',
							'324.7px 997.1px',
							'326.1px 997.1px',
							'327.7px 997.1px',
							'329.4px 997.1px',
							'331.1px 997.1px',
							'332.4px 996.7px',
							'333.2px 996.1px',
							'333.8px 995.2px',
							'335.1px 994.6px',
							'337.0px 994.4px',
							'339.6px 994.7px',
							'342.0px 995.1px',
							'344.3px 995.4px',
							'346.5px 995.5px',
							'348.7px 995.5px',
							'351.0px 995.1px',
							'353.4px 994.4px',
							'355.9px 993.3px',
							'357.8px 992.6px',
							'359.1px 992.2px',
							'359.8px 992.2px',
							'360.0px 992.2px',
							'360.0px 992.2px',
							'359.6px 992.2px',
							'359.0px 992.3px',
							'358.5px 992.4px',
							'358.0px 992.7px',
							'357.4px 993.2px',
							'356.5px 993.5px',
							'355.3px 993.7px',
							'354.0px 993.7px',
							'352.7px 993.7px',
							'351.3px 993.7px',
							'349.8px 993.8px',
							'348.1px 993.8px',
							'346.7px 994.1px',
							'345.8px 994.7px',
							'345.3px 995.7px',
							'344.6px 996.3px',
							'343.6px 996.6px',
							'342.2px 996.7px',
							'340.9px 996.7px',
							'339.8px 996.7px',
							'338.8px 996.7px',
							'338.0px 996.7px',
							'337.3px 996.2px',
							'336.7px 995.3px',
							'336.1px 993.9px',
							'335.8px 992.9px',
							'335.8px 992.4px',
							'336.6px 992.4px',
							'337.9px 992.4px',
							'339.8px 992.3px',
							'342.0px 992.3px',
							'344.5px 992.3px',
							'347.1px 992.2px',
							'349.8px 992.2px',
							'352.7px 992.2px',
							'355.7px 992.2px',
							'359.0px 992.2px',
							'362.2px 992.1px',
							'365.3px 992.1px',
							'368.3px 991.9px',
							'371.0px 991.5px',
							'373.7px 991.0px',
							'376.0px 991.2px',
							'377.9px 992.3px',
							'379.2px 994.1px',
							'380.3px 995.4px',
							'381.3px 996.0px',
							'382.2px 995.9px',
							'382.7px 995.9px',
							'382.7px 995.9px',
							'382.1px 995.9px',
							'381.3px 995.9px',
							'379.8px 995.8px',
							'377.8px 995.6px',
							'375.0px 995.3px',
							'372.4px 995.1px',
							'369.8px 995.1px',
							'367.4px 995.1px',
							'364.8px 995.2px',
							'362.1px 995.3px',
							'359.2px 995.3px',
							'356.4px 995.4px',
							'353.9px 995.1px',
							'351.9px 994.5px',
							'350.3px 993.5px',
							'348.5px 992.8px',
							'346.6px 992.5px',
							'344.6px 992.6px',
							'342.9px 992.6px',
							'341.4px 992.6px',
							'340.0px 992.6px',
							'338.7px 992.7px',
							'337.2px 993.0px',
							'335.4px 993.7px',
							'333.3px 994.7px',
							'331.9px 995.4px',
							'331.2px 995.7px',
							'331.2px 995.7px',
							'331.3px 995.7px',
							'331.4px 995.7px',
							'331.6px 995.7px',
							'331.8px 995.7px',
							'332.3px 995.6px',
							'332.9px 995.6px',
							'333.6px 995.6px',
							'334.0px 995.6px',
							'333.9px 995.6px',
							'333.5px 995.6px',
							'333.1px 995.6px',
							'332.9px 995.6px',
							'332.9px 995.6px',
							'333.2px 995.6px',
							'333.7px 995.1px',
							'334.0px 994.2px',
							'334.2px 992.8px',
							'334.3px 991.9px',
							'334.5px 991.5px',
							'335.0px 991.5px',
							'335.7px 991.5px',
							'336.5px 991.5px',
							'337.3px 991.4px',
							'338.1px 991.4px',
							'339.6px 991.7px',
							'341.8px 992.3px',
							'345.0px 993.0px',
							'347.6px 993.6px',
							'349.5px 993.8px',
							'350.8px 993.7px',
							'352.2px 993.7px',
							'353.5px 993.7px',
							'354.9px 993.6px',
							'356.1px 993.6px',
							'356.9px 993.9px',
							'357.3px 994.6px',
							'357.3px 995.6px',
							'357.4px 996.2px',
							'357.7px 996.5px',
							'358.2px 996.5px',
							'358.6px 996.5px',
							'359.0px 996.5px',
							'359.1px 996.5px',
							'359.2px 996.5px',
							'359.2px 996.2px',
							'359.2px 995.6px',
							'359.0px 994.6px',
							'358.4px 994.0px',
							'357.4px 993.6px',
							'356.1px 993.6px',
							'354.8px 993.6px',
							'353.3px 993.5px',
							'351.9px 993.5px',
							'350.5px 993.4px',
							'349.1px 993.3px',
							'347.7px 993.3px',
							'346.2px 993.2px',
							'344.8px 993.2px',
							'343.4px 993.1px',
							'342.0px 993.1px',
							'340.6px 993.0px',
							'339.1px 993.0px',
							'337.7px 992.9px',
							'336.3px 992.8px',
							'334.9px 992.8px',
							'333.5px 992.7px',
							'332.0px 992.7px',
							'330.6px 992.6px',
							'329.4px 992.6px',
							'328.3px 992.6px',
							'327.0px 992.7px',
							'325.8px 992.7px',
							'324.6px 992.7px',
							'323.5px 992.7px',
							'321.8px 992.7px',
							'319.7px 992.8px',
							'317.0px 992.8px',
							'315.2px 992.9px',
							'314.2px 992.9px',
							'314.0px 992.9px',
							'314.0px 992.9px',
							'314.0px 992.9px',
							'314.3px 992.9px',
							'315.0px 992.9px',
							'316.6px 992.9px',
							'319.2px 992.8px',
							'322.6px 992.6px',
							'325.5px 992.5px',
							'327.7px 992.5px',
							'329.4px 992.5px',
							'331.1px 992.4px',
							'332.8px 992.4px',
							'334.6px 992.4px',
							'336.3px 992.3px',
							'337.9px 992.3px',
							'339.4px 992.3px',
							'340.7px 992.3px',
							'341.9px 992.3px',
							'343.0px 992.3px',
							'344.0px 992.3px',
							'344.9px 992.2px',
							'345.8px 992.2px',
							'346.6px 992.2px',
							'347.3px 992.2px',
							'346.7px 992.6px',
							'344.8px 993.6px',
							'341.5px 995.1px',
							'339.5px 996.4px',
							'338.6px 997.1px',
							'339.1px 997.2px',
							'339.7px 997.2px',
							'340.1px 997.2px',
							'340.4px 997.2px',
							'340.5px 997.2px',
							'341.0px 996.7px',
							'341.7px 995.8px',
							'342.8px 994.3px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					scale: interpolate(frame, [7], [0.446], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					}),
					rotate: interpolate(
						frame,
						[
							7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
							24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
							40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
							56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
							72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
							88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
							116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128,
							129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141,
							142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154,
							155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167,
							168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180,
							181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
							194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206,
							207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219,
							220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
							233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245,
							246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258,
							259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271,
							272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284,
							285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297,
							298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310,
							311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323,
							324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336,
							337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349,
							350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362,
							363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375,
							376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388,
							389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401,
							402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414,
							415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427,
							428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440,
							441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453,
							454, 455,
						],
						[
							'86.8deg',
							'87.1deg',
							'86.2deg',
							'87.9deg',
							'88.4deg',
							'86.3deg',
							'86.2deg',
							'86.1deg',
							'82.8deg',
							'82.6deg',
							'82.6deg',
							'82.3deg',
							'82.1deg',
							'82deg',
							'82.1deg',
							'82.1deg',
							'82.4deg',
							'82.1deg',
							'87.9deg',
							'88deg',
							'87.4deg',
							'87.9deg',
							'87.4deg',
							'87.9deg',
							'87.9deg',
							'86.8deg',
							'87.1deg',
							'87.8deg',
							'88.3deg',
							'88.2deg',
							'88.0deg',
							'87.9deg',
							'87.8deg',
							'87.7deg',
							'87.5deg',
							'87.5deg',
							'87.4deg',
							'87.2deg',
							'85.6deg',
							'85.5deg',
							'85.4deg',
							'85.4deg',
							'85.3deg',
							'85.3deg',
							'85.1deg',
							'85.1deg',
							'85.1deg',
							'84.9deg',
							'86.2deg',
							'86.2deg',
							'86.1deg',
							'86.1deg',
							'86.0deg',
							'85.9deg',
							'85.9deg',
							'85.9deg',
							'85.9deg',
							'85.9deg',
							'84.2deg',
							'84.2deg',
							'84.2deg',
							'84.2deg',
							'84.3deg',
							'84.2deg',
							'84.2deg',
							'84.3deg',
							'84.3deg',
							'84.2deg',
							'83.5deg',
							'83.4deg',
							'83.3deg',
							'83.2deg',
							'83.1deg',
							'83.0deg',
							'82.8deg',
							'82.7deg',
							'82.5deg',
							'82.3deg',
							'84.3deg',
							'84.3deg',
							'84.1deg',
							'84.0deg',
							'84.0deg',
							'83.9deg',
							'83.8deg',
							'83.8deg',
							'83.3deg',
							'82.9deg',
							'82.4deg',
							'82.0deg',
							'81.5deg',
							'81.1deg',
							'81.2deg',
							'81.3deg',
							'81.3deg',
							'81.5deg',
							'81.6deg',
							'81.7deg',
							'79.9deg',
							'79.9deg',
							'80.0deg',
							'80.2deg',
							'80.2deg',
							'80.3deg',
							'80.5deg',
							'80.6deg',
							'81.1deg',
							'81.6deg',
							'82.2deg',
							'82.7deg',
							'83.2deg',
							'83.7deg',
							'83.7deg',
							'83.6deg',
							'83.6deg',
							'83.6deg',
							'83.5deg',
							'83.5deg',
							'83.3deg',
							'83.3deg',
							'83.2deg',
							'83.1deg',
							'83.1deg',
							'82.9deg',
							'82.8deg',
							'82.8deg',
							'82.7deg',
							'82.6deg',
							'83.9deg',
							'83.8deg',
							'83.8deg',
							'83.8deg',
							'83.8deg',
							'83.8deg',
							'83.8deg',
							'83.8deg',
							'83.8deg',
							'83.8deg',
							'84.0deg',
							'84.1deg',
							'84.0deg',
							'84.0deg',
							'84.1deg',
							'84.0deg',
							'84.0deg',
							'84.0deg',
							'84.0deg',
							'84.0deg',
							'84.0deg',
							'84.0deg',
							'84.0deg',
							'84.0deg',
							'84.0deg',
							'84.0deg',
							'84.1deg',
							'84.2deg',
							'84.4deg',
							'84.6deg',
							'84.9deg',
							'85.1deg',
							'85.2deg',
							'85.2deg',
							'85.1deg',
							'85.1deg',
							'85.0deg',
							'84.9deg',
							'84.7deg',
							'84.2deg',
							'83.6deg',
							'83.2deg',
							'82.9deg',
							'82.9deg',
							'82.9deg',
							'82.9deg',
							'82.9deg',
							'82.9deg',
							'83.0deg',
							'83.1deg',
							'83.2deg',
							'83.3deg',
							'83.5deg',
							'83.7deg',
							'83.9deg',
							'84.1deg',
							'84.3deg',
							'84.6deg',
							'84.9deg',
							'85.4deg',
							'85.9deg',
							'86.3deg',
							'86.6deg',
							'86.7deg',
							'86.8deg',
							'87.0deg',
							'87.1deg',
							'87.2deg',
							'87.3deg',
							'87.2deg',
							'87.1deg',
							'87.0deg',
							'87.0deg',
							'86.9deg',
							'87.0deg',
							'87.0deg',
							'87.0deg',
							'86.9deg',
							'86.9deg',
							'86.8deg',
							'86.7deg',
							'86.6deg',
							'86.5deg',
							'86.4deg',
							'86.4deg',
							'86.4deg',
							'86.3deg',
							'86.3deg',
							'86.2deg',
							'85.9deg',
							'85.5deg',
							'85.3deg',
							'85.2deg',
							'85.3deg',
							'85.3deg',
							'85.4deg',
							'85.4deg',
							'85.4deg',
							'85.5deg',
							'85.7deg',
							'85.9deg',
							'86.0deg',
							'86.1deg',
							'86.0deg',
							'86.0deg',
							'85.9deg',
							'85.8deg',
							'85.7deg',
							'85.7deg',
							'85.7deg',
							'85.8deg',
							'85.8deg',
							'85.8deg',
							'85.6deg',
							'85.4deg',
							'85.3deg',
							'85.1deg',
							'85.0deg',
							'84.7deg',
							'84.4deg',
							'84.1deg',
							'83.8deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.8deg',
							'83.8deg',
							'83.8deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.8deg',
							'83.9deg',
							'83.9deg',
							'84.0deg',
							'84.1deg',
							'84.1deg',
							'84.1deg',
							'84.1deg',
							'84.1deg',
							'84.1deg',
							'84.2deg',
							'84.2deg',
							'84.3deg',
							'84.3deg',
							'84.3deg',
							'84.3deg',
							'84.3deg',
							'84.3deg',
							'84.3deg',
							'84.3deg',
							'84.2deg',
							'84.1deg',
							'84.1deg',
							'83.9deg',
							'83.8deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.6deg',
							'83.4deg',
							'83.2deg',
							'83.1deg',
							'82.9deg',
							'82.8deg',
							'82.7deg',
							'82.6deg',
							'82.5deg',
							'82.4deg',
							'82.3deg',
							'82.2deg',
							'82.2deg',
							'82.2deg',
							'82.2deg',
							'82.2deg',
							'82.3deg',
							'82.6deg',
							'83.0deg',
							'83.4deg',
							'83.6deg',
							'83.8deg',
							'84.0deg',
							'84.3deg',
							'84.5deg',
							'84.8deg',
							'84.9deg',
							'84.9deg',
							'84.7deg',
							'84.6deg',
							'84.6deg',
							'84.8deg',
							'84.9deg',
							'85.0deg',
							'85.1deg',
							'85.1deg',
							'85.3deg',
							'85.4deg',
							'85.7deg',
							'85.8deg',
							'85.9deg',
							'85.9deg',
							'85.9deg',
							'85.8deg',
							'85.8deg',
							'85.8deg',
							'85.7deg',
							'85.6deg',
							'85.5deg',
							'85.4deg',
							'85.4deg',
							'85.4deg',
							'85.4deg',
							'85.4deg',
							'85.4deg',
							'85.4deg',
							'85.5deg',
							'85.6deg',
							'85.8deg',
							'86.0deg',
							'86.1deg',
							'86.1deg',
							'86.1deg',
							'86.0deg',
							'86.0deg',
							'86.0deg',
							'85.8deg',
							'85.4deg',
							'84.8deg',
							'84.4deg',
							'84.1deg',
							'84.0deg',
							'83.9deg',
							'83.8deg',
							'83.7deg',
							'83.5deg',
							'83.5deg',
							'83.6deg',
							'83.7deg',
							'83.8deg',
							'83.8deg',
							'83.8deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.7deg',
							'83.8deg',
							'83.8deg',
							'83.9deg',
							'84.0deg',
							'84.0deg',
							'84.1deg',
							'84.1deg',
							'84.2deg',
							'84.3deg',
							'84.3deg',
							'84.4deg',
							'84.4deg',
							'84.5deg',
							'84.6deg',
							'84.6deg',
							'84.7deg',
							'84.7deg',
							'84.8deg',
							'84.9deg',
							'84.9deg',
							'85.0deg',
							'85.1deg',
							'85.1deg',
							'85.2deg',
							'85.3deg',
							'85.3deg',
							'85.5deg',
							'85.6deg',
							'85.9deg',
							'86.0deg',
							'86.1deg',
							'86.2deg',
							'86.2deg',
							'86.2deg',
							'86.2deg',
							'86.1deg',
							'85.9deg',
							'85.6deg',
							'85.1deg',
							'84.7deg',
							'84.5deg',
							'84.4deg',
							'84.3deg',
							'84.2deg',
							'84.1deg',
							'84.0deg',
							'83.9deg',
							'83.9deg',
							'83.9deg',
							'83.9deg',
							'83.9deg',
							'83.8deg',
							'83.7deg',
							'83.7deg',
							'83.6deg',
							'83.6deg',
							'83.9deg',
							'84.6deg',
							'85.6deg',
							'86.2deg',
							'86.6deg',
							'86.6deg',
							'86.5deg',
							'86.5deg',
							'86.5deg',
							'86.5deg',
							'86.4deg',
							'86.2deg',
							'85.8deg',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			>
				<Skills2Announcement
					title="/remotion-maps"
					revealScale={interpolate(frame, [7, 13], [0, 1], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					})}
				/>
			</Sequence>
			<Sequence
				name="Remotion create 1"
				width={1071}
				height={102}
				durationInFrames={456}
				style={{
					position: 'absolute',
					translate: interpolate(
						frame,
						[
							5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
							23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
							39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54,
							55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
							71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86,
							87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
							116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128,
							129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141,
							142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154,
							155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167,
							168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180,
							181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
							194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206,
							207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219,
							220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
							233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245,
							246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258,
							259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271,
							272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284,
							285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297,
							298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310,
							311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323,
							324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336,
							337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349,
							350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362,
							363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375,
							376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388,
							389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401,
							402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414,
							415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427,
							428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440,
							441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453,
							454, 455,
						],
						[
							'344.7px 504.4px',
							'356.6px 520.7px',
							'377.5px 589.1px',
							'385.0px 727.2px',
							'410.9px 810.8px',
							'422.1px 914.2px',
							'419.2px 1001.4px',
							'422.5px 1004.9px',
							'420.8px 1001.7px',
							'419.3px 1004.5px',
							'440.8px 1000.8px',
							'441.5px 999.4px',
							'444.8px 997.4px',
							'441.2px 999.0px',
							'444.0px 996.2px',
							'445.8px 996.3px',
							'445.5px 994.7px',
							'444.4px 996.3px',
							'444.3px 998.1px',
							'442.6px 999.7px',
							'443.7px 1000.7px',
							'442.9px 1000.6px',
							'443.2px 999.4px',
							'442.2px 999.4px',
							'441.9px 999.9px',
							'446.3px 995.5px',
							'446.6px 995.4px',
							'447.1px 994.6px',
							'448.9px 997.0px',
							'447.7px 996.0px',
							'449.8px 1001.8px',
							'449.7px 1001.8px',
							'443.9px 1001.9px',
							'438.2px 1001.9px',
							'432.4px 1002.0px',
							'426.7px 1002.1px',
							'420.9px 1002.1px',
							'415.2px 1002.2px',
							'409.4px 1002.3px',
							'403.7px 1002.3px',
							'397.9px 1002.4px',
							'398.7px 1002.4px',
							'400.2px 1002.4px',
							'397.8px 1002.1px',
							'401.5px 1002.3px',
							'403.8px 1002.4px',
							'406.8px 1002.5px',
							'412.2px 1002.7px',
							'416.3px 1002.4px',
							'420.3px 1002.1px',
							'424.4px 1001.8px',
							'428.4px 1001.6px',
							'432.5px 1001.3px',
							'436.5px 1001.0px',
							'440.6px 1000.7px',
							'437.3px 1000.8px',
							'433.6px 1000.9px',
							'429.7px 1001.0px',
							'425.8px 1001.0px',
							'421.7px 1001.1px',
							'427.4px 1003.1px',
							'423.2px 1004.5px',
							'419.3px 1004.6px',
							'415.4px 1004.7px',
							'411.3px 1004.8px',
							'407.6px 1004.9px',
							'404.2px 1004.9px',
							'401.0px 1005.0px',
							'398.4px 1005.1px',
							'396.4px 1005.1px',
							'398.7px 1000.6px',
							'398.1px 1000.6px',
							'398.4px 1000.6px',
							'399.0px 1000.6px',
							'399.6px 1000.6px',
							'400.6px 1000.6px',
							'401.6px 1000.5px',
							'402.7px 1000.5px',
							'403.9px 1000.5px',
							'405.2px 1000.4px',
							'397.3px 998.4px',
							'398.3px 998.3px',
							'399.5px 998.3px',
							'400.6px 998.3px',
							'401.7px 998.3px',
							'402.7px 998.2px',
							'403.6px 998.2px',
							'404.4px 998.2px',
							'407.4px 998.7px',
							'410.4px 999.1px',
							'413.4px 999.5px',
							'416.5px 1000.0px',
							'419.5px 1000.5px',
							'422.5px 1000.9px',
							'422.4px 1001.0px',
							'422.4px 1001.0px',
							'422.2px 1001.0px',
							'421.9px 1001.0px',
							'421.5px 1001.0px',
							'421.2px 1001.0px',
							'420.5px 1001.0px',
							'420.0px 1001.1px',
							'419.5px 1001.1px',
							'419.0px 1001.1px',
							'418.8px 1001.1px',
							'418.8px 1001.1px',
							'419.1px 1001.1px',
							'419.7px 1001.1px',
							'418.9px 1000.8px',
							'418.1px 1000.5px',
							'417.4px 1000.2px',
							'416.6px 1000.0px',
							'415.8px 999.7px',
							'415.0px 999.4px',
							'418.1px 999.4px',
							'421.7px 999.3px',
							'425.8px 999.2px',
							'430.0px 999.1px',
							'434.9px 999.0px',
							'439.9px 998.9px',
							'445.3px 1001.6px',
							'451.6px 1001.3px',
							'458.3px 1001.1px',
							'465.2px 1000.7px',
							'470.7px 1000.4px',
							'465.6px 1000.7px',
							'460.5px 1001.1px',
							'455.4px 1001.4px',
							'450.2px 1001.8px',
							'445.1px 1002.1px',
							'440.0px 1002.5px',
							'434.9px 1002.8px',
							'434.9px 1002.8px',
							'434.9px 1002.8px',
							'435.0px 1002.8px',
							'435.1px 1002.8px',
							'435.2px 1002.8px',
							'435.2px 1002.8px',
							'437.0px 1002.6px',
							'438.7px 1002.4px',
							'440.5px 1002.2px',
							'442.3px 1002.0px',
							'444.0px 1001.8px',
							'445.8px 1001.6px',
							'443.3px 1001.6px',
							'443.5px 1001.5px',
							'443.5px 1001.4px',
							'443.5px 1001.4px',
							'443.5px 1001.3px',
							'443.5px 1001.2px',
							'443.5px 1001.2px',
							'443.5px 1001.1px',
							'443.5px 1001.0px',
							'443.5px 1001.0px',
							'443.5px 1000.9px',
							'443.5px 1000.8px',
							'442.9px 1000.8px',
							'442.2px 1000.8px',
							'441.4px 1001.1px',
							'440.7px 1001.7px',
							'439.9px 1002.6px',
							'438.9px 1003.2px',
							'437.6px 1003.5px',
							'436.0px 1003.5px',
							'434.4px 1003.5px',
							'432.6px 1003.5px',
							'430.7px 1003.5px',
							'428.5px 1003.5px',
							'426.8px 1003.5px',
							'425.7px 1003.5px',
							'425.2px 1003.5px',
							'424.4px 1003.5px',
							'423.2px 1003.5px',
							'421.6px 1003.5px',
							'420.1px 1003.5px',
							'418.6px 1003.5px',
							'417.2px 1003.5px',
							'416.2px 1003.5px',
							'414.7px 1003.1px',
							'412.7px 1002.2px',
							'410.1px 1000.8px',
							'408.7px 999.9px',
							'408.5px 999.4px',
							'409.2px 999.4px',
							'410.0px 999.4px',
							'410.8px 999.4px',
							'412.0px 999.5px',
							'413.4px 999.5px',
							'414.4px 999.9px',
							'414.9px 1000.8px',
							'415.1px 1002.0px',
							'416.1px 1002.9px',
							'417.4px 1003.3px',
							'419.1px 1003.3px',
							'420.4px 1003.3px',
							'421.7px 1003.3px',
							'422.9px 1003.4px',
							'424.3px 1003.4px',
							'425.6px 1003.4px',
							'426.9px 1003.4px',
							'427.9px 1003.4px',
							'428.6px 1003.4px',
							'429.2px 1003.4px',
							'429.7px 1003.4px',
							'430.2px 1003.4px',
							'430.8px 1003.4px',
							'431.2px 1003.4px',
							'431.6px 1003.4px',
							'432.6px 1003.0px',
							'434.4px 1002.1px',
							'436.6px 1000.8px',
							'438.1px 1000.0px',
							'439.0px 999.5px',
							'439.5px 999.5px',
							'440.2px 999.5px',
							'440.8px 999.5px',
							'441.3px 999.5px',
							'442.0px 999.5px',
							'443.4px 999.8px',
							'445.4px 1000.4px',
							'448.0px 1001.3px',
							'450.3px 1001.9px',
							'452.1px 1002.1px',
							'453.7px 1002.1px',
							'455.2px 1002.1px',
							'456.6px 1002.1px',
							'457.8px 1002.1px',
							'458.8px 1002.1px',
							'460.1px 1002.3px',
							'461.5px 1002.5px',
							'463.1px 1003.1px',
							'463.9px 1003.7px',
							'464.1px 1004.3px',
							'463.3px 1004.6px',
							'462.2px 1004.7px',
							'460.7px 1004.7px',
							'458.9px 1004.8px',
							'456.9px 1004.8px',
							'455.1px 1004.5px',
							'453.4px 1003.9px',
							'452.0px 1003.0px',
							'449.7px 1002.5px',
							'446.9px 1002.5px',
							'443.5px 1003.0px',
							'440.2px 1003.3px',
							'437.0px 1003.5px',
							'433.7px 1003.5px',
							'430.5px 1003.5px',
							'426.3px 1003.4px',
							'421.2px 1003.1px',
							'415.2px 1002.6px',
							'411.1px 1002.2px',
							'408.7px 1002.0px',
							'407.9px 1002.0px',
							'407.6px 1002.0px',
							'407.4px 1002.0px',
							'407.6px 1002.0px',
							'408.0px 1002.0px',
							'409.5px 1002.0px',
							'412.1px 1002.1px',
							'415.8px 1002.1px',
							'419.0px 1002.2px',
							'421.6px 1002.2px',
							'423.8px 1002.2px',
							'426.2px 1002.2px',
							'428.8px 1002.2px',
							'431.4px 1002.2px',
							'434.3px 1002.2px',
							'437.4px 1002.2px',
							'440.9px 1002.2px',
							'444.4px 1002.2px',
							'447.8px 1002.2px',
							'451.1px 1002.2px',
							'453.9px 1002.2px',
							'456.4px 1002.2px',
							'458.6px 1002.1px',
							'460.8px 1002.1px',
							'462.8px 1002.1px',
							'464.1px 1002.4px',
							'464.8px 1003.0px',
							'464.6px 1003.9px',
							'464.4px 1004.5px',
							'464.1px 1004.8px',
							'463.9px 1004.8px',
							'463.2px 1004.8px',
							'462.4px 1004.8px',
							'461.6px 1004.8px',
							'460.8px 1004.8px',
							'461.1px 1004.4px',
							'462.2px 1003.5px',
							'464.1px 1002.1px',
							'464.8px 1001.2px',
							'464.3px 1000.7px',
							'462.8px 1000.7px',
							'461.4px 1000.8px',
							'460.1px 1000.8px',
							'458.8px 1000.8px',
							'457.5px 1000.8px',
							'455.8px 1001.1px',
							'453.5px 1001.7px',
							'451.1px 1002.6px',
							'448.9px 1003.2px',
							'447.1px 1003.5px',
							'445.7px 1003.5px',
							'444.3px 1003.5px',
							'443.1px 1003.5px',
							'441.8px 1003.4px',
							'440.4px 1003.4px',
							'439.1px 1003.3px',
							'437.7px 1003.2px',
							'436.4px 1003.1px',
							'435.1px 1003.1px',
							'433.7px 1003.0px',
							'432.4px 1002.9px',
							'431.1px 1002.8px',
							'429.7px 1002.7px',
							'428.4px 1002.6px',
							'427.1px 1002.5px',
							'425.7px 1002.4px',
							'424.4px 1002.4px',
							'423.1px 1002.3px',
							'421.7px 1002.2px',
							'420.7px 1002.1px',
							'419.9px 1002.0px',
							'419.5px 1002.0px',
							'419.2px 1002.0px',
							'418.8px 1002.0px',
							'418.3px 1002.0px',
							'418.6px 1001.9px',
							'419.7px 1001.6px',
							'421.6px 1001.2px',
							'422.9px 1001.0px',
							'423.5px 1000.8px',
							'423.6px 1000.8px',
							'423.8px 1000.8px',
							'424.1px 1000.9px',
							'424.7px 1000.9px',
							'425.2px 1000.9px',
							'425.8px 1001.0px',
							'426.3px 1001.3px',
							'426.9px 1001.7px',
							'427.2px 1002.0px',
							'427.3px 1002.2px',
							'427.1px 1002.2px',
							'426.6px 1002.2px',
							'425.8px 1002.2px',
							'424.8px 1002.2px',
							'423.5px 1002.2px',
							'422.7px 1002.3px',
							'422.2px 1002.6px',
							'421.9px 1003.1px',
							'421.2px 1003.4px',
							'420.2px 1003.5px',
							'419.0px 1003.5px',
							'417.7px 1003.5px',
							'416.3px 1003.5px',
							'414.8px 1003.5px',
							'413.4px 1003.5px',
							'411.9px 1003.5px',
							'410.4px 1003.5px',
							'408.8px 1003.5px',
							'407.5px 1003.5px',
							'406.6px 1003.5px',
							'406.1px 1003.5px',
							'405.8px 1003.5px',
							'405.5px 1003.5px',
							'405.5px 1003.5px',
							'405.5px 1003.5px',
							'405.4px 1003.3px',
							'404.8px 1003.0px',
							'404.2px 1002.5px',
							'404.3px 1002.1px',
							'405.1px 1002.0px',
							'406.2px 1002.0px',
							'407.5px 1002.0px',
							'409.3px 1002.0px',
							'411.6px 1002.1px',
							'414.0px 1002.1px',
							'415.7px 1002.4px',
							'416.7px 1003.0px',
							'417.0px 1003.7px',
							'417.7px 1004.0px',
							'419.0px 1003.9px',
							'420.9px 1003.6px',
							'422.9px 1003.4px',
							'424.8px 1003.4px',
							'426.6px 1003.5px',
							'428.3px 1003.5px',
							'429.2px 1003.5px',
							'429.4px 1003.4px',
							'428.8px 1003.4px',
							'428.8px 1003.3px',
							'429.3px 1003.3px',
							'430.6px 1003.3px',
							'431.4px 1003.3px',
							'432.3px 1003.3px',
							'433.0px 1003.3px',
							'433.7px 1003.3px',
							'434.9px 1002.9px',
							'436.5px 1002.1px',
							'439.0px 1000.8px',
							'441.0px 1000.0px',
							'442.6px 999.5px',
							'443.1px 999.5px',
							'443.3px 999.5px',
							'443.3px 999.5px',
							'443.3px 999.5px',
							'443.2px 999.5px',
							'443.7px 1000.0px',
							'444.5px 1000.9px',
							'445.7px 1002.2px',
							'446.5px 1003.1px',
							'447.0px 1003.5px',
							'447.3px 1003.5px',
							'447.8px 1003.5px',
							'448.3px 1003.5px',
							'448.6px 1003.5px',
							'448.7px 1003.5px',
							'449.5px 1003.4px',
							'451.1px 1003.0px',
							'453.4px 1002.6px',
							'455.1px 1002.2px',
							'456.2px 1002.1px',
							'456.7px 1002.1px',
							'457.4px 1002.1px',
							'458.0px 1002.1px',
							'458.7px 1002.1px',
							'459.4px 1002.1px',
							'460.7px 1001.9px',
							'462.2px 1001.6px',
							'464.2px 1001.1px',
							'465.4px 1000.8px',
							'466.0px 1000.7px',
							'465.8px 1000.7px',
							'465.4px 1000.7px',
							'464.7px 1000.7px',
							'463.8px 1000.7px',
							'462.6px 1000.7px',
							'460.4px 1001.0px',
							'457.4px 1001.7px',
							'453.6px 1002.6px',
							'450.5px 1003.2px',
							'448.2px 1003.5px',
							'446.6px 1003.5px',
							'444.9px 1003.5px',
							'442.9px 1003.5px',
							'440.8px 1003.5px',
							'439.2px 1003.5px',
							'437.4px 1003.5px',
							'435.2px 1003.5px',
							'432.6px 1003.5px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					scale: interpolate(frame, [5], [0.446], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					}),
					rotate: interpolate(
						frame,
						[
							5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
							23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
							39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54,
							55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
							71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86,
							87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
							116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128,
							129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141,
							142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154,
							155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167,
							168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180,
							181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
							194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206,
							207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219,
							220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232,
							233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245,
							246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258,
							259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271,
							272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284,
							285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297,
							298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310,
							311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323,
							324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336,
							337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349,
							350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362,
							363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375,
							376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388,
							389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401,
							402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414,
							415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427,
							428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440,
							441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453,
							454, 455,
						],
						[
							'83.4deg',
							'84.6deg',
							'83.8deg',
							'84.7deg',
							'80.7deg',
							'82.6deg',
							'85.3deg',
							'85.6deg',
							'85.8deg',
							'85.6deg',
							'82.0deg',
							'81.3deg',
							'81.2deg',
							'81.3deg',
							'80.7deg',
							'80.7deg',
							'80.6deg',
							'80.7deg',
							'80.7deg',
							'80.8deg',
							'80.4deg',
							'80.5deg',
							'80.3deg',
							'80.4deg',
							'80.6deg',
							'80.6deg',
							'80.4deg',
							'80.2deg',
							'80.4deg',
							'80.3deg',
							'80.6deg',
							'80.6deg',
							'82.2deg',
							'83.7deg',
							'85.3deg',
							'86.8deg',
							'88.4deg',
							'89.9deg',
							'91.5deg',
							'93.0deg',
							'94.6deg',
							'94.5deg',
							'94.4deg',
							'95.5deg',
							'94.9deg',
							'94.7deg',
							'94.3deg',
							'93.3deg',
							'92.1deg',
							'90.8deg',
							'89.6deg',
							'88.3deg',
							'87.1deg',
							'85.8deg',
							'84.6deg',
							'84.7deg',
							'85.0deg',
							'85.3deg',
							'85.5deg',
							'85.8deg',
							'83.2deg',
							'83.5deg',
							'83.6deg',
							'83.9deg',
							'84.1deg',
							'84.4deg',
							'84.6deg',
							'84.8deg',
							'85.0deg',
							'85.2deg',
							'84.2deg',
							'84.3deg',
							'84.3deg',
							'84.2deg',
							'84.2deg',
							'84.1deg',
							'84.0deg',
							'83.9deg',
							'83.8deg',
							'83.7deg',
							'86.0deg',
							'85.9deg',
							'85.8deg',
							'85.7deg',
							'85.6deg',
							'85.5deg',
							'85.5deg',
							'85.4deg',
							'84.8deg',
							'84.2deg',
							'83.6deg',
							'82.9deg',
							'82.3deg',
							'81.7deg',
							'81.7deg',
							'81.7deg',
							'81.7deg',
							'81.8deg',
							'81.8deg',
							'81.8deg',
							'81.9deg',
							'81.9deg',
							'82.0deg',
							'82.0deg',
							'82.0deg',
							'82.0deg',
							'82.0deg',
							'82.0deg',
							'82.5deg',
							'83.0deg',
							'83.5deg',
							'83.9deg',
							'84.4deg',
							'84.9deg',
							'84.7deg',
							'84.5deg',
							'84.2deg',
							'84.0deg',
							'83.7deg',
							'83.4deg',
							'83.0deg',
							'82.5deg',
							'81.9deg',
							'81.3deg',
							'80.6deg',
							'82.3deg',
							'84.0deg',
							'85.7deg',
							'87.5deg',
							'89.2deg',
							'90.9deg',
							'92.6deg',
							'92.6deg',
							'92.6deg',
							'92.6deg',
							'92.6deg',
							'92.6deg',
							'92.6deg',
							'92.1deg',
							'91.6deg',
							'91.1deg',
							'90.6deg',
							'90.1deg',
							'89.6deg',
							'90.3deg',
							'91.8deg',
							'91.5deg',
							'91.2deg',
							'91.0deg',
							'90.7deg',
							'90.4deg',
							'90.1deg',
							'89.8deg',
							'89.6deg',
							'89.3deg',
							'89.0deg',
							'89.1deg',
							'89.1deg',
							'89.2deg',
							'89.4deg',
							'89.6deg',
							'89.8deg',
							'90.0deg',
							'90.2deg',
							'90.3deg',
							'90.3deg',
							'90.4deg',
							'90.6deg',
							'90.6deg',
							'90.3deg',
							'89.9deg',
							'89.7deg',
							'89.6deg',
							'89.7deg',
							'89.7deg',
							'89.8deg',
							'89.9deg',
							'90.0deg',
							'90.2deg',
							'90.6deg',
							'91.3deg',
							'91.7deg',
							'91.9deg',
							'91.8deg',
							'91.8deg',
							'91.8deg',
							'91.7deg',
							'91.7deg',
							'91.8deg',
							'92.0deg',
							'92.4deg',
							'92.6deg',
							'92.7deg',
							'92.6deg',
							'92.6deg',
							'92.5deg',
							'92.4deg',
							'92.3deg',
							'92.2deg',
							'92.0deg',
							'91.9deg',
							'91.8deg',
							'91.8deg',
							'91.8deg',
							'91.7deg',
							'91.7deg',
							'91.7deg',
							'91.6deg',
							'91.5deg',
							'91.2deg',
							'90.8deg',
							'90.6deg',
							'90.5deg',
							'90.5deg',
							'90.4deg',
							'90.3deg',
							'90.3deg',
							'90.2deg',
							'90.0deg',
							'89.7deg',
							'89.3deg',
							'89.0deg',
							'88.8deg',
							'88.7deg',
							'88.6deg',
							'88.5deg',
							'88.4deg',
							'88.3deg',
							'88.3deg',
							'88.2deg',
							'88.0deg',
							'87.9deg',
							'87.8deg',
							'87.8deg',
							'88.0deg',
							'88.1deg',
							'88.3deg',
							'88.5deg',
							'88.5deg',
							'88.4deg',
							'88.0deg',
							'88.0deg',
							'88.0deg',
							'88.2deg',
							'88.5deg',
							'88.7deg',
							'88.9deg',
							'89.2deg',
							'89.7deg',
							'90.6deg',
							'91.6deg',
							'92.3deg',
							'92.6deg',
							'92.6deg',
							'92.6deg',
							'92.6deg',
							'92.6deg',
							'92.6deg',
							'92.4deg',
							'92.0deg',
							'91.3deg',
							'90.8deg',
							'90.5deg',
							'90.4deg',
							'90.3deg',
							'90.2deg',
							'90.1deg',
							'89.9deg',
							'89.7deg',
							'89.6deg',
							'89.4deg',
							'89.3deg',
							'89.1deg',
							'89.0deg',
							'88.9deg',
							'88.8deg',
							'88.7deg',
							'88.5deg',
							'88.6deg',
							'88.7deg',
							'89.1deg',
							'89.3deg',
							'89.3deg',
							'89.3deg',
							'89.3deg',
							'89.4deg',
							'89.5deg',
							'89.5deg',
							'89.3deg',
							'88.9deg',
							'88.3deg',
							'87.9deg',
							'87.8deg',
							'87.9deg',
							'88.0deg',
							'88.1deg',
							'88.1deg',
							'88.1deg',
							'88.3deg',
							'88.6deg',
							'89.0deg',
							'89.3deg',
							'89.5deg',
							'89.6deg',
							'89.7deg',
							'89.8deg',
							'90.0deg',
							'90.1deg',
							'90.3deg',
							'90.5deg',
							'90.6deg',
							'90.8deg',
							'91.0deg',
							'91.1deg',
							'91.3deg',
							'91.5deg',
							'91.6deg',
							'91.8deg',
							'92.0deg',
							'92.2deg',
							'92.3deg',
							'92.5deg',
							'92.6deg',
							'92.7deg',
							'92.6deg',
							'92.6deg',
							'92.7deg',
							'92.8deg',
							'92.6deg',
							'92.2deg',
							'91.5deg',
							'91.0deg',
							'90.7deg',
							'90.7deg',
							'90.7deg',
							'90.6deg',
							'90.5deg',
							'90.5deg',
							'90.5deg',
							'90.5deg',
							'90.5deg',
							'90.6deg',
							'90.6deg',
							'90.6deg',
							'90.6deg',
							'90.6deg',
							'90.7deg',
							'90.8deg',
							'90.7deg',
							'90.5deg',
							'90.3deg',
							'90.2deg',
							'90.2deg',
							'90.3deg',
							'90.3deg',
							'90.4deg',
							'90.5deg',
							'90.6deg',
							'90.7deg',
							'90.9deg',
							'91.1deg',
							'91.3deg',
							'91.4deg',
							'91.5deg',
							'91.5deg',
							'91.5deg',
							'91.5deg',
							'91.5deg',
							'91.6deg',
							'92.0deg',
							'92.4deg',
							'92.6deg',
							'92.7deg',
							'92.6deg',
							'92.5deg',
							'92.4deg',
							'92.1deg',
							'91.9deg',
							'91.8deg',
							'91.8deg',
							'91.8deg',
							'91.9deg',
							'91.8deg',
							'91.7deg',
							'91.6deg',
							'91.5deg',
							'91.4deg',
							'91.4deg',
							'91.5deg',
							'91.7deg',
							'92.3deg',
							'92.6deg',
							'92.7deg',
							'92.6deg',
							'92.6deg',
							'92.5deg',
							'92.5deg',
							'92.4deg',
							'92.2deg',
							'91.7deg',
							'90.9deg',
							'90.4deg',
							'90.0deg',
							'90.0deg',
							'89.9deg',
							'89.9deg',
							'89.9deg',
							'90.0deg',
							'89.9deg',
							'89.8deg',
							'89.7deg',
							'89.7deg',
							'89.6deg',
							'89.5deg',
							'89.4deg',
							'89.4deg',
							'89.4deg',
							'89.5deg',
							'89.3deg',
							'88.9deg',
							'88.5deg',
							'88.1deg',
							'88.0deg',
							'88.0deg',
							'87.9deg',
							'87.9deg',
							'87.8deg',
							'87.8deg',
							'87.7deg',
							'87.6deg',
							'87.5deg',
							'87.4deg',
							'87.3deg',
							'87.3deg',
							'87.4deg',
							'87.4deg',
							'87.5deg',
							'87.5deg',
							'87.8deg',
							'88.2deg',
							'88.9deg',
							'89.4deg',
							'89.6deg',
							'89.7deg',
							'89.8deg',
							'90.1deg',
							'90.3deg',
							'90.4deg',
							'90.4deg',
							'90.5deg',
							'90.7deg',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			>
				<Skills2Announcement
					title="/remotion-create"
					revealScale={interpolate(frame, [5, 11], [0, 1], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					})}
				/>
			</Sequence>
			<Sequence
				name="Remotion captions"
				width={1071}
				height={102}
				durationInFrames={456}
				style={{
					position: 'absolute',
					translate: interpolate(
						frame,
						[
							4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
							22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
							38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53,
							54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69,
							70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85,
							86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101,
							102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114,
							115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
							128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140,
							141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153,
							154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166,
							167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179,
							180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192,
							193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205,
							206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218,
							219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231,
							232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244,
							245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257,
							258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270,
							271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283,
							284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296,
							297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309,
							310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322,
							323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335,
							336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348,
							349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361,
							362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374,
							375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387,
							388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400,
							401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413,
							414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426,
							427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439,
							440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452,
							453, 454, 455,
						],
						[
							'436.6px 529.3px',
							'444.5px 621.9px',
							'444.7px 675.5px',
							'446.0px 742.8px',
							'454.8px 877.7px',
							'436.2px 970.0px',
							'440.1px 1004.0px',
							'437.1px 1003.3px',
							'439.4px 1006.7px',
							'438.3px 1003.5px',
							'438.9px 1006.4px',
							'451.5px 1004.1px',
							'452.7px 1003.0px',
							'452.5px 1001.2px',
							'451.4px 1002.7px',
							'450.7px 1000.2px',
							'454.5px 1000.2px',
							'452.0px 998.8px',
							'453.4px 1000.2px',
							'452.9px 1002.0px',
							'450.1px 1003.5px',
							'454.6px 1006.1px',
							'451.4px 1004.5px',
							'446.2px 1003.5px',
							'443.0px 1003.4px',
							'439.7px 1003.9px',
							'443.3px 999.5px',
							'441.9px 999.5px',
							'432.2px 998.9px',
							'439.2px 1001.0px',
							'428.7px 1000.2px',
							'426.3px 1004.4px',
							'422.3px 1004.4px',
							'427.2px 1003.8px',
							'432.1px 1003.1px',
							'436.9px 1002.5px',
							'441.8px 1001.8px',
							'446.7px 1001.1px',
							'451.6px 1000.5px',
							'456.4px 999.9px',
							'461.3px 999.2px',
							'466.2px 998.5px',
							'471.1px 997.9px',
							'475.9px 997.2px',
							'480.8px 996.6px',
							'480.3px 996.9px',
							'480.6px 996.9px',
							'479.9px 997.1px',
							'476.4px 997.8px',
							'468.3px 998.5px',
							'460.2px 999.2px',
							'452.1px 999.9px',
							'444.0px 1000.5px',
							'435.9px 1001.2px',
							'427.8px 1001.9px',
							'419.7px 1002.6px',
							'420.9px 1002.6px',
							'421.8px 1002.6px',
							'422.6px 1002.6px',
							'423.1px 1002.6px',
							'423.5px 1002.6px',
							'427.1px 1004.2px',
							'427.1px 1004.2px',
							'427.0px 1004.2px',
							'426.5px 1004.2px',
							'425.8px 1004.2px',
							'425.2px 1004.2px',
							'424.2px 1004.1px',
							'423.4px 1004.1px',
							'422.3px 1004.1px',
							'421.4px 1004.1px',
							'430.8px 1003.0px',
							'430.1px 1003.0px',
							'428.8px 1003.0px',
							'427.8px 1003.0px',
							'426.6px 1003.0px',
							'425.3px 1003.0px',
							'423.8px 1003.0px',
							'422.6px 1003.0px',
							'421.5px 1003.0px',
							'420.3px 1003.0px',
							'411.5px 1001.4px',
							'410.8px 1000.0px',
							'410.1px 999.9px',
							'409.7px 999.9px',
							'409.5px 999.9px',
							'409.6px 999.9px',
							'410.0px 999.9px',
							'410.5px 999.9px',
							'414.5px 1000.6px',
							'418.4px 1001.4px',
							'422.4px 1002.1px',
							'426.4px 1002.9px',
							'430.3px 1003.6px',
							'434.3px 1004.4px',
							'436.3px 1004.4px',
							'438.4px 1004.3px',
							'440.5px 1004.3px',
							'442.6px 1002.9px',
							'444.9px 1002.9px',
							'447.0px 1002.9px',
							'440.6px 1003.0px',
							'442.2px 1003.0px',
							'443.8px 1003.0px',
							'445.2px 1003.0px',
							'446.6px 1003.0px',
							'448.1px 1003.0px',
							'449.5px 1003.0px',
							'451.2px 1003.0px',
							'449.7px 1002.7px',
							'448.2px 1002.5px',
							'446.8px 1002.2px',
							'445.3px 1001.9px',
							'443.8px 1001.7px',
							'442.3px 1001.4px',
							'442.8px 1001.4px',
							'443.1px 1001.4px',
							'443.1px 1001.4px',
							'442.9px 1001.4px',
							'442.6px 1001.4px',
							'442.2px 1001.4px',
							'449.7px 1003.0px',
							'449.0px 1003.0px',
							'448.1px 1003.0px',
							'447.4px 1003.0px',
							'444.6px 1003.0px',
							'454.8px 1002.2px',
							'465.1px 1001.4px',
							'475.3px 1000.6px',
							'485.5px 999.8px',
							'495.8px 999.0px',
							'506.0px 998.2px',
							'510.3px 998.0px',
							'513.9px 997.8px',
							'516.6px 997.7px',
							'518.8px 997.5px',
							'520.4px 997.5px',
							'521.2px 997.4px',
							'521.3px 997.4px',
							'520.6px 997.5px',
							'519.2px 997.5px',
							'522.5px 996.3px',
							'519.4px 996.4px',
							'515.7px 996.6px',
							'510.9px 996.9px',
							'507.3px 996.8px',
							'503.7px 996.7px',
							'495.3px 996.6px',
							'486.9px 996.6px',
							'478.5px 996.5px',
							'470.0px 996.5px',
							'461.6px 996.4px',
							'453.2px 996.4px',
							'444.8px 996.3px',
							'436.4px 996.2px',
							'428.0px 996.2px',
							'419.6px 996.1px',
							'410.8px 996.3px',
							'402.5px 996.6px',
							'394.9px 997.2px',
							'388.0px 998.3px',
							'382.3px 999.9px',
							'378.0px 1001.0px',
							'375.0px 1001.5px',
							'373.0px 1001.5px',
							'371.7px 1001.5px',
							'371.0px 1001.5px',
							'370.7px 1001.5px',
							'370.9px 1001.5px',
							'372.2px 1001.5px',
							'374.9px 1001.4px',
							'378.8px 1001.3px',
							'382.4px 1001.2px',
							'385.6px 1001.0px',
							'388.5px 1001.0px',
							'391.5px 1000.9px',
							'394.6px 1000.8px',
							'397.7px 1000.8px',
							'401.2px 1000.7px',
							'404.3px 1000.3px',
							'407.0px 999.4px',
							'409.1px 998.1px',
							'411.5px 997.0px',
							'414.0px 996.3px',
							'416.3px 996.1px',
							'418.2px 996.1px',
							'419.9px 996.0px',
							'421.6px 996.0px',
							'423.2px 996.0px',
							'423.0px 996.6px',
							'420.9px 997.7px',
							'417.0px 999.5px',
							'413.4px 1000.6px',
							'410.7px 1001.2px',
							'408.5px 1001.2px',
							'406.0px 1001.3px',
							'403.2px 1001.3px',
							'400.4px 1001.3px',
							'397.2px 1001.4px',
							'393.9px 1001.6px',
							'390.7px 1001.9px',
							'387.8px 1002.4px',
							'385.1px 1002.7px',
							'382.7px 1002.9px',
							'380.7px 1002.9px',
							'379.2px 1002.9px',
							'378.3px 1002.9px',
							'377.5px 1002.9px',
							'377.1px 1002.9px',
							'377.6px 1002.6px',
							'379.3px 1001.9px',
							'382.0px 1000.9px',
							'384.8px 1000.2px',
							'387.5px 999.9px',
							'390.3px 999.8px',
							'393.2px 999.8px',
							'396.4px 999.8px',
							'399.8px 999.6px',
							'403.5px 999.2px',
							'408.1px 998.6px',
							'413.1px 998.3px',
							'418.5px 998.2px',
							'423.1px 998.5px',
							'426.8px 998.7px',
							'429.3px 998.8px',
							'431.1px 998.8px',
							'432.0px 998.8px',
							'432.3px 998.8px',
							'432.0px 998.8px',
							'431.2px 999.3px',
							'429.7px 1000.4px',
							'427.8px 1001.9px',
							'425.4px 1003.0px',
							'422.6px 1003.6px',
							'419.4px 1003.6px',
							'415.9px 1003.7px',
							'412.1px 1003.8px',
							'408.2px 1003.9px',
							'404.2px 1004.0px',
							'400.1px 1003.9px',
							'396.0px 1003.6px',
							'392.1px 1003.2px',
							'388.7px 1002.9px',
							'385.7px 1002.8px',
							'383.1px 1002.8px',
							'380.8px 1002.8px',
							'379.1px 1002.8px',
							'377.8px 1002.9px',
							'377.2px 1002.9px',
							'377.2px 1002.5px',
							'377.8px 1001.9px',
							'379.2px 1000.9px',
							'381.6px 1000.2px',
							'384.6px 999.9px',
							'388.4px 999.8px',
							'392.8px 999.8px',
							'397.6px 999.7px',
							'402.9px 999.7px',
							'408.2px 999.6px',
							'413.9px 999.6px',
							'419.9px 999.8px',
							'426.4px 1000.0px',
							'432.1px 1000.1px',
							'436.8px 1000.1px',
							'440.4px 1000.0px',
							'443.1px 999.9px',
							'445.3px 999.8px',
							'446.7px 999.8px',
							'447.4px 999.7px',
							'447.2px 999.8px',
							'446.0px 999.9px',
							'443.9px 1000.1px',
							'441.4px 1000.2px',
							'438.7px 1000.3px',
							'435.5px 1000.4px',
							'431.9px 1000.4px',
							'427.7px 1000.5px',
							'423.3px 1000.7px',
							'418.6px 1001.1px',
							'412.6px 1001.4px',
							'405.5px 1001.2px',
							'397.7px 1000.7px',
							'391.2px 1000.2px',
							'386.4px 999.9px',
							'383.0px 999.9px',
							'380.2px 1000.0px',
							'377.9px 1000.0px',
							'376.3px 1000.0px',
							'375.4px 1000.0px',
							'375.9px 999.8px',
							'377.6px 999.5px',
							'380.5px 998.9px',
							'383.6px 998.5px',
							'386.8px 998.3px',
							'390.3px 998.3px',
							'394.4px 998.2px',
							'399.1px 998.1px',
							'404.4px 998.0px',
							'409.9px 997.9px',
							'415.2px 998.3px',
							'420.4px 999.2px',
							'425.5px 1000.6px',
							'431.1px 1001.5px',
							'436.8px 1001.8px',
							'442.6px 1001.7px',
							'447.3px 1001.6px',
							'450.3px 1001.5px',
							'451.1px 1001.3px',
							'450.4px 1001.2px',
							'448.9px 1001.1px',
							'447.5px 1001.0px',
							'446.1px 1000.9px',
							'444.7px 1000.8px',
							'443.3px 1000.7px',
							'441.9px 1000.6px',
							'440.5px 1000.5px',
							'439.1px 1000.3px',
							'437.7px 1000.2px',
							'436.3px 1000.1px',
							'434.9px 1000.0px',
							'433.5px 999.9px',
							'432.1px 999.8px',
							'430.7px 999.7px',
							'429.1px 999.5px',
							'427.0px 999.5px',
							'424.2px 999.5px',
							'420.8px 999.5px',
							'417.2px 999.6px',
							'413.5px 999.6px',
							'410.1px 999.6px',
							'406.9px 999.6px',
							'404.2px 999.6px',
							'401.1px 999.6px',
							'397.9px 999.6px',
							'394.5px 999.7px',
							'391.4px 999.7px',
							'388.5px 999.8px',
							'386.0px 999.8px',
							'383.7px 999.8px',
							'381.9px 1000.2px',
							'380.5px 1000.8px',
							'379.6px 1001.7px',
							'378.9px 1002.4px',
							'378.4px 1002.7px',
							'378.1px 1002.7px',
							'378.0px 1002.7px',
							'378.2px 1002.7px',
							'378.5px 1002.7px',
							'379.0px 1002.7px',
							'379.2px 1002.4px',
							'379.3px 1001.8px',
							'379.2px 1000.9px',
							'379.7px 1000.2px',
							'380.7px 999.9px',
							'382.1px 999.9px',
							'383.4px 999.9px',
							'384.7px 999.9px',
							'386.2px 999.8px',
							'387.8px 999.8px',
							'390.1px 999.7px',
							'392.8px 999.6px',
							'396.3px 999.5px',
							'398.9px 999.3px',
							'400.7px 999.3px',
							'401.6px 999.2px',
							'402.5px 999.2px',
							'403.2px 999.2px',
							'403.9px 999.2px',
							'404.3px 999.2px',
							'403.8px 999.7px',
							'402.1px 1000.8px',
							'399.4px 1002.4px',
							'397.2px 1003.5px',
							'395.5px 1004.0px',
							'394.0px 1004.1px',
							'392.0px 1004.1px',
							'389.2px 1004.1px',
							'385.8px 1004.3px',
							'381.7px 1004.5px',
							'376.6px 1004.5px',
							'370.8px 1003.7px',
							'364.4px 1002.7px',
							'359.2px 1001.9px',
							'355.3px 1001.6px',
							'353.0px 1001.5px',
							'351.3px 1001.5px',
							'350.0px 1001.4px',
							'348.7px 1001.3px',
							'347.4px 1001.2px',
							'346.1px 1001.2px',
							'344.7px 1001.1px',
							'343.4px 1001.0px',
							'342.1px 1000.9px',
							'340.8px 1000.9px',
							'339.5px 1000.8px',
							'338.1px 1000.7px',
							'336.8px 1000.6px',
							'335.5px 1000.6px',
							'334.2px 1000.5px',
							'332.9px 1000.4px',
							'331.5px 1000.3px',
							'330.6px 1000.3px',
							'330.3px 1000.2px',
							'331.3px 1000.2px',
							'333.4px 1000.2px',
							'336.3px 1000.2px',
							'339.4px 1000.1px',
							'342.7px 1000.1px',
							'346.2px 1000.1px',
							'349.7px 1000.2px',
							'353.0px 1000.5px',
							'356.2px 1001.2px',
							'359.6px 1001.8px',
							'363.4px 1002.4px',
							'367.6px 1002.7px',
							'371.8px 1002.8px',
							'376.0px 1002.8px',
							'379.9px 1002.7px',
							'383.7px 1002.7px',
							'387.5px 1002.3px',
							'391.2px 1001.6px',
							'395.0px 1000.5px',
							'398.7px 999.8px',
							'402.2px 999.4px',
							'405.3px 999.3px',
							'408.2px 999.2px',
							'410.9px 999.2px',
							'413.5px 999.1px',
							'415.9px 999.0px',
							'418.4px 999.0px',
							'421.1px 998.9px',
							'424.0px 998.8px',
							'426.4px 998.8px',
							'428.0px 998.7px',
							'428.7px 998.7px',
							'428.8px 998.7px',
							'428.4px 998.7px',
							'427.7px 998.7px',
							'426.7px 998.7px',
							'424.1px 999.2px',
							'420.2px 1000.1px',
							'414.9px 1001.4px',
							'410.8px 1002.4px',
							'407.8px 1003.1px',
							'406.0px 1003.6px',
							'404.3px 1004.0px',
							'402.7px 1004.1px',
							'401.3px 1004.2px',
							'400.1px 1004.2px',
							'399.1px 1003.9px',
							'398.1px 1003.2px',
							'397.3px 1002.3px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					scale: interpolate(frame, [4], [0.446], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					}),
					rotate: interpolate(
						frame,
						[
							4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
							22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
							38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53,
							54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69,
							70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85,
							86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101,
							102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114,
							115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
							128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140,
							141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153,
							154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166,
							167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179,
							180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192,
							193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205,
							206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218,
							219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231,
							232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244,
							245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257,
							258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270,
							271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283,
							284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296,
							297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309,
							310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322,
							323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335,
							336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348,
							349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361,
							362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374,
							375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387,
							388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400,
							401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413,
							414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426,
							427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439,
							440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452,
							453, 454, 455,
						],
						[
							'90.7deg',
							'89.8deg',
							'91.5deg',
							'90.8deg',
							'88.1deg',
							'92.5deg',
							'91.2deg',
							'91.9deg',
							'92.4deg',
							'92.1deg',
							'91.7deg',
							'89.9deg',
							'88.7deg',
							'89.9deg',
							'89.3deg',
							'89.8deg',
							'89.2deg',
							'89.3deg',
							'88.3deg',
							'88.0deg',
							'88.3deg',
							'87.8deg',
							'87.4deg',
							'88.0deg',
							'87.9deg',
							'88.6deg',
							'88.0deg',
							'87.9deg',
							'89.9deg',
							'88.1deg',
							'89.9deg',
							'90.7deg',
							'90.8deg',
							'89.6deg',
							'88.5deg',
							'87.3deg',
							'86.2deg',
							'85.0deg',
							'83.9deg',
							'82.8deg',
							'81.6deg',
							'80.5deg',
							'79.3deg',
							'78.2deg',
							'77.0deg',
							'77.5deg',
							'77.6deg',
							'77.8deg',
							'78.8deg',
							'80.9deg',
							'83.1deg',
							'85.2deg',
							'87.4deg',
							'89.5deg',
							'91.7deg',
							'93.8deg',
							'93.7deg',
							'93.7deg',
							'93.6deg',
							'93.6deg',
							'93.6deg',
							'92.7deg',
							'92.7deg',
							'92.7deg',
							'92.8deg',
							'92.8deg',
							'92.9deg',
							'92.9deg',
							'93.0deg',
							'93.0deg',
							'93.1deg',
							'90.4deg',
							'90.4deg',
							'90.5deg',
							'90.6deg',
							'90.6deg',
							'90.7deg',
							'90.8deg',
							'90.8deg',
							'90.9deg',
							'90.9deg',
							'92.9deg',
							'92.9deg',
							'92.9deg',
							'92.9deg',
							'93.0deg',
							'92.9deg',
							'92.9deg',
							'92.9deg',
							'92.2deg',
							'91.5deg',
							'90.8deg',
							'90.2deg',
							'89.5deg',
							'88.8deg',
							'88.7deg',
							'88.6deg',
							'88.5deg',
							'88.4deg',
							'88.2deg',
							'88.1deg',
							'90.4deg',
							'90.3deg',
							'90.2deg',
							'90.2deg',
							'90.1deg',
							'90.1deg',
							'90.0deg',
							'89.9deg',
							'90.3deg',
							'90.7deg',
							'91.2deg',
							'91.6deg',
							'92.0deg',
							'92.4deg',
							'92.3deg',
							'92.3deg',
							'92.3deg',
							'92.3deg',
							'92.3deg',
							'92.4deg',
							'90.1deg',
							'90.2deg',
							'90.3deg',
							'90.3deg',
							'90.4deg',
							'88.6deg',
							'86.7deg',
							'84.8deg',
							'83.0deg',
							'81.2deg',
							'79.3deg',
							'79.0deg',
							'78.7deg',
							'78.5deg',
							'78.4deg',
							'78.3deg',
							'78.2deg',
							'78.2deg',
							'78.3deg',
							'78.3deg',
							'76.7deg',
							'76.9deg',
							'77.1deg',
							'77.5deg',
							'77.4deg',
							'77.3deg',
							'77.9deg',
							'78.6deg',
							'79.2deg',
							'79.9deg',
							'80.5deg',
							'81.2deg',
							'81.8deg',
							'82.5deg',
							'83.1deg',
							'83.8deg',
							'84.4deg',
							'85.0deg',
							'85.7deg',
							'86.3deg',
							'86.9deg',
							'87.4deg',
							'87.7deg',
							'87.9deg',
							'88.0deg',
							'88.0deg',
							'88.1deg',
							'88.1deg',
							'87.8deg',
							'87.3deg',
							'86.6deg',
							'86.0deg',
							'85.6deg',
							'85.4deg',
							'85.2deg',
							'84.9deg',
							'84.7deg',
							'84.4deg',
							'84.2deg',
							'84.1deg',
							'84.0deg',
							'83.9deg',
							'83.8deg',
							'83.7deg',
							'83.6deg',
							'83.5deg',
							'83.5deg',
							'83.4deg',
							'83.7deg',
							'84.3deg',
							'85.2deg',
							'85.9deg',
							'86.3deg',
							'86.4deg',
							'86.6deg',
							'86.7deg',
							'86.9deg',
							'87.1deg',
							'87.2deg',
							'87.2deg',
							'87.2deg',
							'87.2deg',
							'87.3deg',
							'87.4deg',
							'87.4deg',
							'87.5deg',
							'87.5deg',
							'87.5deg',
							'87.5deg',
							'87.3deg',
							'87.1deg',
							'86.9deg',
							'86.7deg',
							'86.6deg',
							'86.5deg',
							'86.3deg',
							'86.1deg',
							'85.9deg',
							'85.6deg',
							'85.0deg',
							'84.3deg',
							'83.8deg',
							'83.5deg',
							'83.3deg',
							'83.3deg',
							'83.2deg',
							'83.2deg',
							'83.3deg',
							'83.4deg',
							'83.6deg',
							'83.9deg',
							'84.1deg',
							'84.4deg',
							'84.6deg',
							'84.9deg',
							'85.1deg',
							'85.4deg',
							'85.7deg',
							'86.0deg',
							'86.2deg',
							'86.4deg',
							'86.6deg',
							'86.8deg',
							'86.9deg',
							'87.1deg',
							'87.2deg',
							'87.3deg',
							'87.3deg',
							'87.3deg',
							'87.2deg',
							'87.0deg',
							'86.9deg',
							'86.7deg',
							'86.6deg',
							'86.4deg',
							'86.1deg',
							'85.9deg',
							'85.6deg',
							'85.2deg',
							'84.6deg',
							'84.0deg',
							'83.4deg',
							'83.0deg',
							'82.7deg',
							'82.5deg',
							'82.3deg',
							'82.2deg',
							'82.2deg',
							'82.3deg',
							'82.6deg',
							'83.0deg',
							'83.3deg',
							'83.5deg',
							'83.6deg',
							'83.7deg',
							'83.8deg',
							'84.0deg',
							'84.2deg',
							'84.6deg',
							'85.2deg',
							'86.0deg',
							'86.6deg',
							'87.0deg',
							'87.1deg',
							'87.3deg',
							'87.4deg',
							'87.4deg',
							'87.5deg',
							'87.4deg',
							'87.2deg',
							'86.8deg',
							'86.5deg',
							'86.3deg',
							'86.1deg',
							'85.8deg',
							'85.5deg',
							'85.1deg',
							'84.8deg',
							'84.5deg',
							'84.3deg',
							'84.2deg',
							'83.9deg',
							'83.7deg',
							'83.4deg',
							'83.1deg',
							'82.9deg',
							'82.9deg',
							'83.0deg',
							'83.1deg',
							'83.2deg',
							'83.3deg',
							'83.5deg',
							'83.6deg',
							'83.7deg',
							'83.8deg',
							'84.0deg',
							'84.1deg',
							'84.2deg',
							'84.3deg',
							'84.5deg',
							'84.6deg',
							'84.7deg',
							'84.8deg',
							'85.0deg',
							'85.1deg',
							'85.3deg',
							'85.5deg',
							'85.6deg',
							'85.7deg',
							'85.7deg',
							'85.6deg',
							'85.6deg',
							'85.7deg',
							'85.9deg',
							'86.1deg',
							'86.2deg',
							'86.4deg',
							'86.5deg',
							'86.6deg',
							'86.5deg',
							'86.5deg',
							'86.4deg',
							'86.4deg',
							'86.4deg',
							'86.4deg',
							'86.4deg',
							'86.4deg',
							'86.4deg',
							'86.5deg',
							'86.6deg',
							'86.9deg',
							'87.0deg',
							'87.0deg',
							'86.9deg',
							'86.8deg',
							'86.7deg',
							'86.6deg',
							'86.5deg',
							'86.2deg',
							'85.7deg',
							'85.1deg',
							'84.7deg',
							'84.5deg',
							'84.4deg',
							'84.4deg',
							'84.3deg',
							'84.3deg',
							'84.2deg',
							'84.4deg',
							'84.8deg',
							'85.4deg',
							'85.8deg',
							'86.1deg',
							'86.1deg',
							'86.2deg',
							'86.4deg',
							'86.6deg',
							'86.9deg',
							'87.3deg',
							'87.8deg',
							'88.4deg',
							'88.8deg',
							'89.0deg',
							'89.1deg',
							'89.1deg',
							'89.1deg',
							'89.1deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.2deg',
							'89.3deg',
							'89.3deg',
							'89.2deg',
							'89.2deg',
							'89.0deg',
							'88.8deg',
							'88.6deg',
							'88.4deg',
							'88.3deg',
							'88.1deg',
							'87.9deg',
							'87.8deg',
							'87.6deg',
							'87.4deg',
							'87.1deg',
							'86.9deg',
							'86.7deg',
							'86.5deg',
							'86.4deg',
							'86.1deg',
							'85.8deg',
							'85.4deg',
							'85.1deg',
							'84.8deg',
							'84.6deg',
							'84.4deg',
							'84.2deg',
							'84.0deg',
							'83.8deg',
							'83.7deg',
							'83.5deg',
							'83.4deg',
							'83.2deg',
							'83.1deg',
							'83.1deg',
							'83.0deg',
							'83.0deg',
							'83.1deg',
							'83.1deg',
							'83.5deg',
							'84.2deg',
							'85.1deg',
							'85.8deg',
							'86.1deg',
							'86.2deg',
							'86.3deg',
							'86.4deg',
							'86.5deg',
							'86.6deg',
							'86.6deg',
							'86.7deg',
							'86.6deg',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			>
				<Skills2Announcement
					title="/remotion-captions"
					revealScale={interpolate(frame, [4, 10], [0, 1], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					})}
				/>
			</Sequence>
			<Sequence
				name="Remotion SaaS"
				width={1071}
				height={102}
				durationInFrames={456}
				style={{
					position: 'absolute',
					translate: interpolate(
						frame,
						[
							2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
							20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
							36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51,
							52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67,
							68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83,
							84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
							100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
							113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125,
							126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138,
							139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151,
							152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164,
							165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177,
							178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190,
							191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203,
							204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216,
							217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229,
							230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242,
							243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255,
							256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268,
							269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281,
							282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294,
							295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307,
							308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320,
							321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333,
							334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346,
							347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359,
							360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372,
							373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385,
							386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398,
							399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411,
							412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424,
							425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437,
							438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450,
							451, 452, 453, 454, 455,
						],
						[
							'575.5px 565.7px',
							'580px 623.5px',
							'585.5px 695.5px',
							'587.8px 777.1px',
							'580.5px 839px',
							'572.9px 877.8px',
							'568.8px 973.6px',
							'569px 976.7px',
							'574.1px 974.2px',
							'576.6px 973.7px',
							'579.2px 977px',
							'582.8px 973.9px',
							'585.4px 976.8px',
							'597.6px 978.7px',
							'602.6px 977.7px',
							'611.6px 975.8px',
							'615.6px 977.3px',
							'621.6px 974.8px',
							'627.2px 974.8px',
							'631.7px 973.3px',
							'636px 974.8px',
							'640.5px 975px',
							'646.5px 976.3px',
							'648.2px 979.2px',
							'653.2px 978.8px',
							'657.4px 977.4px',
							'661.2px 977px',
							'664.7px 977px',
							'668.6px 972.7px',
							'668.1px 972.7px',
							'666.6px 972px',
							'667.3px 974.3px',
							'664.1px 973.4px',
							'658.8px 973.7px',
							'653.6px 973.9px',
							'648.3px 974.2px',
							'643.0px 974.4px',
							'637.8px 974.7px',
							'632.5px 974.9px',
							'627.3px 975.2px',
							'622.0px 975.4px',
							'616.7px 975.7px',
							'611.5px 975.9px',
							'606.2px 976.2px',
							'605.5px 976.2px',
							'604.2px 977.6px',
							'602.9px 977.6px',
							'601.0px 977.5px',
							'598.8px 977.5px',
							'596.0px 977.5px',
							'593.2px 977.5px',
							'590.4px 977.4px',
							'589.0px 977.5px',
							'592.9px 977.6px',
							'589.3px 977.6px',
							'585.7px 977.6px',
							'581.7px 977.5px',
							'577.5px 977.5px',
							'574.4px 977.5px',
							'570.0px 977.4px',
							'565.7px 977.4px',
							'561.5px 977.3px',
							'557.2px 977.2px',
							'553.4px 972.8px',
							'549.4px 972.7px',
							'546.1px 972.6px',
							'542.7px 972.5px',
							'539.1px 972.4px',
							'536.5px 972.3px',
							'534.0px 972.2px',
							'531.6px 972.1px',
							'529.9px 972.1px',
							'528.8px 972.0px',
							'523.8px 976.8px',
							'523.2px 976.8px',
							'522.1px 976.7px',
							'520.2px 976.6px',
							'518.2px 976.5px',
							'516.0px 976.4px',
							'514.0px 976.4px',
							'511.6px 976.3px',
							'509.9px 974.9px',
							'508.3px 974.9px',
							'514.9px 973.4px',
							'513.0px 973.3px',
							'511.3px 973.3px',
							'509.8px 973.3px',
							'508.6px 973.2px',
							'508.2px 973.3px',
							'507.6px 973.2px',
							'507.4px 973.2px',
							'508.1px 973.3px',
							'508.5px 973.4px',
							'514.5px 976.5px',
							'515.3px 976.5px',
							'516.7px 976.5px',
							'518.2px 976.6px',
							'519.6px 976.6px',
							'521.6px 976.6px',
							'523.9px 976.7px',
							'525.7px 976.7px',
							'529.5px 976.8px',
							'533.4px 977.0px',
							'537.2px 977.1px',
							'541.0px 977.2px',
							'544.9px 977.4px',
							'548.7px 977.5px',
							'551.5px 977.5px',
							'554.3px 977.5px',
							'557.0px 977.5px',
							'559.7px 977.5px',
							'561.9px 977.5px',
							'564.8px 977.6px',
							'560.0px 975.8px',
							'562.0px 975.9px',
							'564.4px 975.9px',
							'565.8px 975.9px',
							'567.0px 975.9px',
							'568.8px 976.0px',
							'569.2px 976.0px',
							'569.4px 976.0px',
							'569.8px 976.0px',
							'569.4px 976.0px',
							'566.0px 977.2px',
							'564.9px 977.2px',
							'563.7px 977.2px',
							'562.4px 977.2px',
							'560.9px 977.2px',
							'559.3px 977.1px',
							'557.6px 977.1px',
							'555.3px 977.1px',
							'553.8px 977.0px',
							'552.3px 977.0px',
							'555.7px 975.9px',
							'554.1px 975.9px',
							'552.0px 975.9px',
							'549.3px 977.2px',
							'546.6px 977.1px',
							'543.9px 977.1px',
							'540.8px 976.9px',
							'538.3px 976.9px',
							'536.1px 976.8px',
							'534.7px 976.8px',
							'530.4px 972.2px',
							'529.8px 972.2px',
							'530.1px 972.3px',
							'530.4px 972.3px',
							'531.4px 972.3px',
							'533.4px 972.4px',
							'537.7px 973.0px',
							'541.9px 973.5px',
							'546.2px 974.1px',
							'550.5px 974.7px',
							'554.8px 975.3px',
							'559.0px 975.8px',
							'563.3px 976.4px',
							'567.6px 977.0px',
							'571.9px 977.6px',
							'576.1px 978.1px',
							'582.2px 978.2px',
							'588.3px 978.3px',
							'593.7px 978.2px',
							'598.5px 977.9px',
							'602.5px 977.5px',
							'606.3px 977.2px',
							'610.2px 977.0px',
							'614.1px 977.0px',
							'618.0px 977.0px',
							'621.7px 977.0px',
							'625.0px 977.0px',
							'627.8px 977.0px',
							'630.6px 977.0px',
							'633.4px 977.0px',
							'636.5px 977.0px',
							'638.2px 977.0px',
							'638.7px 977.0px',
							'638.0px 977.0px',
							'636.8px 977.0px',
							'635.0px 977.0px',
							'632.6px 977.0px',
							'629.6px 977.0px',
							'626.1px 977.0px',
							'621.9px 977.0px',
							'616.7px 977.0px',
							'610.8px 976.9px',
							'604.3px 976.6px',
							'597.9px 976.1px',
							'591.7px 975.8px',
							'586.1px 975.6px',
							'580.6px 975.6px',
							'575.3px 975.5px',
							'570.5px 975.5px',
							'566.7px 975.4px',
							'564.0px 975.4px',
							'562.0px 975.3px',
							'560.7px 975.3px',
							'559.8px 975.3px',
							'559.5px 975.3px',
							'559.7px 975.2px',
							'560.4px 975.2px',
							'561.4px 975.2px',
							'561.8px 975.5px',
							'561.9px 976.1px',
							'561.9px 976.9px',
							'563.0px 977.5px',
							'565.1px 977.8px',
							'567.9px 977.9px',
							'570.9px 978.0px',
							'573.8px 978.0px',
							'576.4px 978.1px',
							'578.7px 978.1px',
							'580.9px 977.9px',
							'582.9px 977.3px',
							'584.9px 976.4px',
							'586.5px 975.8px',
							'588.0px 975.5px',
							'588.8px 975.5px',
							'589.0px 975.5px',
							'588.6px 975.5px',
							'587.9px 975.5px',
							'587.0px 975.5px',
							'585.4px 975.3px',
							'583.2px 975.0px',
							'580.3px 974.5px',
							'577.0px 974.2px',
							'573.2px 973.9px',
							'569.1px 973.9px',
							'564.8px 973.8px',
							'560.5px 973.7px',
							'556.3px 973.4px',
							'552.4px 973.0px',
							'548.6px 973.2px',
							'545.0px 974.3px',
							'541.6px 976.4px',
							'539.1px 977.8px',
							'537.4px 978.5px',
							'536.6px 978.5px',
							'536.4px 978.5px',
							'536.8px 978.5px',
							'537.6px 978.6px',
							'539.2px 978.5px',
							'541.9px 978.0px',
							'545.9px 977.0px',
							'550.9px 976.0px',
							'556.1px 975.4px',
							'561.3px 975.2px',
							'566.6px 975.3px',
							'571.8px 975.4px',
							'577.2px 975.5px',
							'582.4px 975.7px',
							'587.9px 976.1px',
							'591.5px 976.2px',
							'593.0px 975.9px',
							'592.0px 975.0px',
							'591.9px 974.0px',
							'592.4px 973.2px',
							'593.5px 972.9px',
							'593.7px 972.8px',
							'593.3px 972.8px',
							'592.6px 972.7px',
							'591.6px 972.7px',
							'590.4px 973.3px',
							'588.8px 974.5px',
							'587.0px 976.4px',
							'584.7px 977.6px',
							'581.9px 978.2px',
							'578.7px 978.1px',
							'575.6px 978.1px',
							'572.4px 978.0px',
							'569.3px 978.0px',
							'566.1px 978.0px',
							'563.6px 977.6px',
							'561.5px 977.0px',
							'560.1px 976.1px',
							'558.3px 975.5px',
							'556.4px 975.2px',
							'554.3px 975.2px',
							'552.5px 975.1px',
							'551.3px 975.1px',
							'550.6px 975.1px',
							'550.8px 975.1px',
							'552.0px 975.2px',
							'554.2px 975.2px',
							'557.5px 975.3px',
							'561.0px 975.4px',
							'564.7px 975.6px',
							'568.4px 975.9px',
							'572.2px 976.4px',
							'575.9px 976.8px',
							'579.4px 977.0px',
							'582.8px 977.0px',
							'584.7px 977.0px',
							'585.2px 977.0px',
							'584.1px 976.9px',
							'583.8px 976.9px',
							'584.1px 976.8px',
							'585.1px 976.8px',
							'585.6px 976.8px',
							'585.4px 976.8px',
							'584.8px 976.8px',
							'583.9px 976.8px',
							'583.0px 976.5px',
							'582.0px 975.9px',
							'580.8px 975.0px',
							'578.9px 974.4px',
							'576.2px 973.9px',
							'573.0px 973.6px',
							'569.7px 973.1px',
							'566.5px 972.7px',
							'563.2px 972.5px',
							'559.8px 972.5px',
							'556.0px 973.0px',
							'551.7px 974.1px',
							'547.3px 975.8px',
							'543.2px 976.9px',
							'539.4px 977.4px',
							'536.0px 977.4px',
							'532.4px 977.3px',
							'528.6px 977.2px',
							'524.8px 977.0px',
							'521.0px 976.9px',
							'517.2px 976.5px',
							'513.2px 975.7px',
							'509.2px 974.5px',
							'505.7px 973.7px',
							'502.7px 973.3px',
							'500.4px 973.2px',
							'498.5px 973.1px',
							'497.0px 973.0px',
							'495.9px 972.9px',
							'495.2px 972.9px',
							'495.2px 972.7px',
							'496.0px 972.6px',
							'497.7px 972.3px',
							'499.8px 972.2px',
							'502.1px 972.3px',
							'504.3px 972.4px',
							'506.7px 972.5px',
							'509.3px 972.6px',
							'512.2px 972.7px',
							'515.1px 972.9px',
							'517.6px 973.3px',
							'519.5px 973.9px',
							'520.9px 974.8px',
							'522.6px 975.5px',
							'524.8px 975.8px',
							'527.6px 975.9px',
							'530.6px 975.9px',
							'533.7px 976.0px',
							'537.0px 976.1px',
							'540.5px 976.2px',
							'544.2px 976.1px',
							'547.6px 975.9px',
							'550.6px 975.4px',
							'553.1px 975.2px',
							'555.5px 975.0px',
							'557.5px 975.1px',
							'559.1px 975.1px',
							'560.4px 975.1px',
							'561.3px 975.1px',
							'561.9px 975.1px',
							'561.7px 975.2px',
							'561.0px 975.5px',
							'559.7px 975.9px',
							'558.6px 976.2px',
							'557.3px 976.3px',
							'556.0px 976.3px',
							'554.4px 976.3px',
							'552.6px 976.2px',
							'550.6px 976.2px',
							'548.7px 976.2px',
							'547.3px 976.2px',
							'546.5px 976.2px',
							'546.4px 976.3px',
							'545.9px 976.4px',
							'545.2px 976.4px',
							'544.4px 976.4px',
							'543.7px 976.4px',
							'543.2px 976.4px',
							'543.2px 976.4px',
							'543.6px 976.4px',
							'544.0px 975.9px',
							'544.0px 975.0px',
							'543.9px 973.6px',
							'544.1px 972.6px',
							'544.7px 972.2px',
							'545.4px 972.2px',
							'546.1px 972.2px',
							'546.6px 972.2px',
							'547.1px 972.2px',
							'547.5px 972.2px',
							'546.8px 972.9px',
							'545.1px 974.3px',
							'542.2px 976.3px',
							'540.1px 977.7px',
							'538.6px 978.3px',
							'537.9px 978.3px',
							'537.0px 978.3px',
							'535.9px 978.3px',
							'534.6px 978.3px',
							'533.0px 978.3px',
							'531.9px 978.0px',
							'531.2px 977.5px',
							'530.8px 976.8px',
							'528.9px 976.3px',
							'525.7px 976.0px',
							'521.2px 975.8px',
							'516.8px 975.7px',
							'512.3px 975.5px',
							'507.9px 975.4px',
							'503.6px 975.2px',
							'499.7px 974.9px',
							'496.4px 974.4px',
							'493.6px 973.8px',
							'491.2px 973.3px',
							'489.3px 973.1px',
							'488.0px 973.0px',
							'487.1px 973.0px',
							'486.9px 973.0px',
							'487.2px 972.9px',
							'488.3px 973.0px',
							'490.2px 973.4px',
							'492.8px 974.1px',
							'496.0px 975.2px',
							'499.3px 976.0px',
							'502.9px 976.4px',
							'506.6px 976.5px',
							'510.5px 976.7px',
							'514.5px 976.8px',
							'518.5px 976.9px',
							'522.4px 977.1px',
							'526.3px 976.9px',
							'530.2px 976.4px',
							'534.0px 975.6px',
							'537.7px 975.1px',
							'541.6px 974.9px',
							'545.9px 975.0px',
							'550.5px 975.1px',
							'555.2px 975.2px',
							'559.8px 975.3px',
							'564.2px 975.4px',
							'568.7px 975.8px',
							'573.3px 976.4px',
							'577.6px 977.4px',
							'581.2px 978.1px',
							'584.0px 978.4px',
							'586.2px 978.4px',
							'588.0px 978.4px',
							'589.4px 978.4px',
							'590.5px 978.4px',
							'591.1px 978.4px',
							'590.7px 978.4px',
							'589.3px 978.4px',
							'586.9px 978.3px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					scale: interpolate(frame, [2], [0.446], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					}),
					rotate: interpolate(
						frame,
						[
							2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 15, 16, 17, 18, 22, 23, 24,
							25, 26, 27, 28, 29, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44,
							45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
							61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76,
							77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92,
							93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106,
							107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119,
							120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132,
							133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145,
							146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158,
							159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171,
							172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184,
							185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197,
							198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210,
							211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223,
							224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236,
							237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249,
							250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262,
							263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275,
							276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288,
							289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301,
							302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314,
							315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327,
							328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340,
							341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353,
							354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366,
							367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379,
							380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392,
							393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405,
							406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418,
							419, 420, 421, 422, 423, 424, 425, 426, 427, 428, 429, 430, 431,
							432, 433, 434, 435, 436, 437, 438, 439, 440, 441, 442, 443, 444,
							445, 446, 447, 448, 449, 450, 451, 452, 453, 454, 455,
						],
						[
							'95.4deg',
							'95.4deg',
							'92.8deg',
							'91.4deg',
							'93deg',
							'95deg',
							'94.8deg',
							'93.7deg',
							'92.7deg',
							'93.6deg',
							'92.6deg',
							'91.5deg',
							'90.3deg',
							'89.6deg',
							'88.7deg',
							'87.5deg',
							'86.5deg',
							'85.4deg',
							'86.6deg',
							'85.3deg',
							'84.3deg',
							'83.3deg',
							'82.4deg',
							'82.7deg',
							'83.5deg',
							'84.4deg',
							'85.2deg',
							'86.0deg',
							'86.8deg',
							'87.7deg',
							'88.5deg',
							'89.3deg',
							'90.1deg',
							'91.0deg',
							'91.8deg',
							'91.9deg',
							'92.0deg',
							'92.0deg',
							'92.2deg',
							'92.3deg',
							'92.6deg',
							'92.8deg',
							'92.9deg',
							'92.5deg',
							'91.3deg',
							'91.6deg',
							'91.8deg',
							'92.1deg',
							'92.5deg',
							'92.5deg',
							'92.9deg',
							'93.3deg',
							'93.6deg',
							'94.1deg',
							'94.8deg',
							'95.2deg',
							'95.5deg',
							'95.8deg',
							'96.2deg',
							'96.5deg',
							'96.7deg',
							'97.0deg',
							'97.2deg',
							'97.3deg',
							'99.1deg',
							'99.1deg',
							'99.2deg',
							'99.4deg',
							'99.6deg',
							'99.8deg',
							'99.9deg',
							'100.1deg',
							'100.1deg',
							'100.0deg',
							'97.3deg',
							'97.4deg',
							'97.6deg',
							'97.7deg',
							'97.7deg',
							'97.6deg',
							'97.7deg',
							'97.7deg',
							'97.5deg',
							'97.4deg',
							'96.6deg',
							'96.6deg',
							'96.5deg',
							'96.3deg',
							'96.3deg',
							'96.2deg',
							'96.0deg',
							'96.0deg',
							'95.4deg',
							'94.8deg',
							'94.2deg',
							'93.7deg',
							'93.1deg',
							'92.5deg',
							'92.4deg',
							'92.3deg',
							'92.2deg',
							'92.1deg',
							'92.1deg',
							'91.8deg',
							'93.9deg',
							'93.9deg',
							'93.6deg',
							'93.6deg',
							'93.5deg',
							'93.2deg',
							'93.2deg',
							'93.2deg',
							'93.0deg',
							'93.0deg',
							'94.1deg',
							'94.2deg',
							'94.2deg',
							'94.2deg',
							'94.3deg',
							'94.3deg',
							'94.4deg',
							'94.7deg',
							'94.7deg',
							'94.8deg',
							'93.5deg',
							'93.6deg',
							'93.8deg',
							'94.2deg',
							'94.4deg',
							'94.7deg',
							'95.1deg',
							'95.4deg',
							'95.6deg',
							'95.7deg',
							'96.7deg',
							'96.7deg',
							'96.6deg',
							'96.6deg',
							'96.5deg',
							'96.2deg',
							'95.9deg',
							'95.6deg',
							'95.3deg',
							'95.0deg',
							'94.7deg',
							'94.4deg',
							'94.1deg',
							'93.8deg',
							'93.5deg',
							'93.2deg',
							'92.8deg',
							'92.3deg',
							'91.9deg',
							'91.5deg',
							'91.3deg',
							'91.1deg',
							'90.9deg',
							'90.7deg',
							'90.5deg',
							'90.2deg',
							'90.1deg',
							'89.9deg',
							'89.7deg',
							'89.5deg',
							'89.1deg',
							'88.9deg',
							'88.7deg',
							'88.7deg',
							'88.7deg',
							'88.7deg',
							'88.7deg',
							'88.8deg',
							'88.9deg',
							'89.1deg',
							'89.4deg',
							'89.8deg',
							'90.3deg',
							'90.7deg',
							'91.1deg',
							'91.4deg',
							'91.8deg',
							'92.2deg',
							'92.6deg',
							'92.9deg',
							'93.1deg',
							'93.3deg',
							'93.5deg',
							'93.6deg',
							'93.7deg',
							'93.8deg',
							'93.8deg',
							'93.8deg',
							'94.0deg',
							'94.3deg',
							'94.6deg',
							'94.7deg',
							'94.6deg',
							'94.3deg',
							'94.0deg',
							'93.7deg',
							'93.4deg',
							'93.2deg',
							'93.0deg',
							'92.9deg',
							'92.7deg',
							'92.6deg',
							'92.4deg',
							'92.2deg',
							'92.2deg',
							'92.2deg',
							'92.2deg',
							'92.2deg',
							'92.3deg',
							'92.4deg',
							'92.7deg',
							'93.0deg',
							'93.4deg',
							'93.8deg',
							'94.2deg',
							'94.6deg',
							'95.0deg',
							'95.3deg',
							'95.6deg',
							'95.9deg',
							'96.2deg',
							'96.5deg',
							'96.7deg',
							'96.7deg',
							'96.7deg',
							'96.7deg',
							'96.6deg',
							'96.5deg',
							'96.2deg',
							'95.7deg',
							'95.0deg',
							'94.4deg',
							'93.8deg',
							'93.3deg',
							'92.8deg',
							'92.3deg',
							'91.8deg',
							'91.3deg',
							'91.0deg',
							'91.0deg',
							'91.5deg',
							'91.8deg',
							'91.9deg',
							'91.9deg',
							'92.0deg',
							'92.1deg',
							'92.2deg',
							'92.3deg',
							'92.5deg',
							'92.6deg',
							'92.7deg',
							'92.9deg',
							'93.1deg',
							'93.3deg',
							'93.5deg',
							'93.7deg',
							'93.9deg',
							'94.1deg',
							'94.2deg',
							'94.2deg',
							'94.1deg',
							'94.0deg',
							'94.0deg',
							'94.1deg',
							'94.2deg',
							'94.3deg',
							'94.3deg',
							'94.2deg',
							'94.1deg',
							'93.8deg',
							'93.5deg',
							'93.2deg',
							'92.9deg',
							'92.6deg',
							'92.3deg',
							'92.0deg',
							'91.7deg',
							'91.5deg',
							'91.5deg',
							'91.7deg',
							'92.2deg',
							'92.6deg',
							'92.7deg',
							'92.7deg',
							'92.7deg',
							'92.8deg',
							'92.8deg',
							'92.9deg',
							'92.9deg',
							'92.8deg',
							'92.6deg',
							'92.6deg',
							'92.7deg',
							'92.9deg',
							'93.1deg',
							'93.3deg',
							'93.5deg',
							'93.8deg',
							'94.1deg',
							'94.6deg',
							'95.1deg',
							'95.5deg',
							'95.8deg',
							'96.1deg',
							'96.3deg',
							'96.6deg',
							'96.9deg',
							'97.2deg',
							'97.6deg',
							'98.0deg',
							'98.5deg',
							'98.9deg',
							'99.1deg',
							'99.3deg',
							'99.5deg',
							'99.6deg',
							'99.8deg',
							'99.9deg',
							'99.8deg',
							'99.6deg',
							'99.1deg',
							'98.7deg',
							'98.4deg',
							'98.1deg',
							'97.9deg',
							'97.6deg',
							'97.3deg',
							'97.0deg',
							'96.8deg',
							'96.7deg',
							'96.7deg',
							'96.7deg',
							'96.6deg',
							'96.4deg',
							'96.2deg',
							'96.0deg',
							'95.8deg',
							'95.5deg',
							'95.3deg',
							'95.0deg',
							'94.9deg',
							'94.8deg',
							'94.6deg',
							'94.6deg',
							'94.5deg',
							'94.4deg',
							'94.4deg',
							'94.4deg',
							'94.5deg',
							'94.6deg',
							'94.8deg',
							'95.0deg',
							'95.1deg',
							'95.2deg',
							'95.2deg',
							'95.3deg',
							'95.4deg',
							'95.5deg',
							'95.5deg',
							'95.3deg',
							'95.0deg',
							'94.8deg',
							'94.7deg',
							'94.7deg',
							'94.8deg',
							'94.8deg',
							'94.8deg',
							'94.8deg',
							'94.8deg',
							'94.9deg',
							'95.0deg',
							'95.0deg',
							'95.0deg',
							'95.0deg',
							'95.0deg',
							'95.0deg',
							'94.9deg',
							'95.0deg',
							'95.2deg',
							'95.7deg',
							'96.4deg',
							'96.9deg',
							'97.1deg',
							'97.2deg',
							'97.2deg',
							'97.3deg',
							'97.3deg',
							'97.4deg',
							'97.2deg',
							'96.8deg',
							'96.3deg',
							'96.0deg',
							'96.1deg',
							'96.5deg',
							'96.9deg',
							'97.3deg',
							'97.7deg',
							'98.0deg',
							'98.4deg',
							'98.7deg',
							'99.0deg',
							'99.3deg',
							'99.4deg',
							'99.6deg',
							'99.6deg',
							'99.7deg',
							'99.7deg',
							'99.7deg',
							'99.5deg',
							'99.3deg',
							'98.9deg',
							'98.6deg',
							'98.4deg',
							'98.1deg',
							'97.8deg',
							'97.5deg',
							'97.2deg',
							'96.8deg',
							'96.5deg',
							'96.2deg',
							'95.9deg',
							'95.6deg',
							'95.2deg',
							'94.8deg',
							'94.4deg',
							'93.9deg',
							'93.5deg',
							'93.0deg',
							'92.6deg',
							'92.1deg',
							'91.7deg',
							'91.4deg',
							'91.2deg',
							'91.1deg',
							'91.0deg',
							'90.9deg',
							'90.9deg',
							'90.9deg',
							'91.1deg',
							'91.5deg',
							'92.1deg',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			>
				<Skills2Announcement
					title="/remotion-saas"
					revealScale={interpolate(frame, [2, 8], [0, 1], {
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					})}
				/>
			</Sequence>
		</Sequence>
	);
};
